window.skxWizard = (function () {
  var STEP_COUNT = 2;
  var _step = 0;
  var _vendorSelected = false;
  var _rateSelected = false;
  var _singleVendor = false;

  function render(fromUserAction) {
    for (var i = 0; i < STEP_COUNT; i++) {
      var panel = document.getElementById('skxw-p' + i);
      var btn   = document.getElementById('skxw-si' + i);
      var conn  = document.getElementById('skxw-conn' + i);
      if (panel) panel.hidden = (i !== _step);
      if (btn) {
        btn.classList.toggle('active', i === _step);
        btn.classList.toggle('done', i < _step);
        btn.setAttribute('aria-selected', String(i === _step));
      }
      if (conn) conn.classList.toggle('done', i < _step);
    }
    if (fromUserAction) {
      var root = document.getElementById('skx-mobile-welcome')
              || document.getElementById('skxWizardRoot')
              || document.getElementById('main-cart-footer');
      if (root) setTimeout(function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
  }

  function goStep(n, fromUserAction) {
    if (n < 0 || n > STEP_COUNT - 1) return;
    _step = n;
    render(fromUserAction);

    if (n === 1) {
      var lbl = document.getElementById('skxw-active-vendor-label');
      if (lbl) lbl.textContent = window._skxActiveVendor || '';
      renderVendorProducts(window._skxActiveVendor);
      if (window._skxActiveVendor && typeof window.handleVendorOpen === 'function') {
        Promise.resolve(window.handleVendorOpen(window._skxActiveVendor))
          .then(function () {
            renderVendorProducts(window._skxActiveVendor);
            if (typeof window.skxTryAutoQuote === 'function') window.skxTryAutoQuote();
          })
          .catch(function () {});
      }
    }

    if (n === 0) {
      var slot = document.getElementById('skxw-vendor-slot');
      var groups = document.getElementById('cartGroupsView');
      if (slot && groups && !slot.contains(groups)) slot.appendChild(groups);
      if (groups) groups.classList.remove('hidden');
      if (typeof window.handleVendorClose === 'function') window.handleVendorClose();
    }
  }

  function tryGoStep(n, fromUserAction) {
    if (n >= 1 && !_vendorSelected) { flashLock('skxw-step1-lock'); return; }
    goStep(n, fromUserAction);
  }

  function flashLock(id) {
    var el = document.getElementById(id);
    if (!el || el.hidden) return;
    el.classList.add('flash');
    setTimeout(function () { el.classList.remove('flash'); }, 1400);
  }

  function setNextButtonEnabled(id, enabled) {
    var btn = document.getElementById(id);
    if (!btn) return;
    btn.classList.toggle('skxw-btn--locked', !enabled);
    btn.setAttribute('aria-disabled', String(!enabled));
  }

  function flashAttention(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('skxw-attn-gold');
    void el.offsetWidth;
    el.classList.add('skxw-attn-gold');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { el.classList.remove('skxw-attn-gold'); }, 1650);
  }

  function tryAdvanceFromStep(currentStep) {
    if (currentStep === 0 && !_vendorSelected) {
      flashLock('skxw-step1-lock');
      flashAttention('skxw-vendor-slot');
      return;
    }
    goStep(currentStep + 1, true);
  }

  function selectVendor(vendorName, opts) {
    opts = opts || {};
    _vendorSelected = true;
    window._skxActiveVendor = vendorName;

    setNextButtonEnabled('skxw-next0', true);
    var lock = document.getElementById('skxw-step1-lock');
    if (lock) lock.hidden = true;

    var slot   = document.getElementById('skxw-vendor-slot');
    var groups = document.getElementById('cartGroupsView');
    if (slot && groups && !slot.contains(groups)) slot.appendChild(groups);

    if (opts.silent) { goStep(1, false); return; }
    setTimeout(function () { goStep(1, true); }, 240);
  }

  function onRateSelected() {
    _rateSelected = true;
    var lock = document.getElementById('skxw-step2-lock');
    if (lock) lock.hidden = true;
    var confirm = document.getElementById('skxw-confirm');
    if (confirm) confirm.hidden = false;
    buildConfirmSummary();
    setTimeout(function () {
      var el = document.getElementById('skxw-confirm');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 140);
  }

  function onRateCleared() {
    _rateSelected = false;
    var lock = document.getElementById('skxw-step2-lock');
    if (lock) lock.hidden = false;
    var confirm = document.getElementById('skxw-confirm');
    if (confirm) confirm.hidden = true;
    var chk = document.getElementById('skxw-terms-chk');
    if (chk) chk.checked = false;
    syncRaleCheckbox(false);
  }

  function termsAccepted() {
    var chk = document.getElementById('skxw-terms-chk');
    return !!(chk && chk.checked);
  }

  function syncRaleCheckbox(accepted) {
    var raleChk = document.querySelector('.rale-container input[type="checkbox"]');
    if (raleChk && raleChk.checked !== accepted) {
      raleChk.checked = accepted;
      raleChk.dispatchEvent(new Event('change', { bubbles: true }));
      raleChk.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  function onTermsChange() {
    var accepted = termsAccepted();
    syncRaleCheckbox(accepted);
    syncShopifyTerms();
    if (typeof window.skxUpdateCheckoutEnabled === 'function') window.skxUpdateCheckoutEnabled();
  }

  function buildConfirmSummary() {
    var vendor = window._skxActiveVendor || '—';
    var s3v = document.getElementById('skxw-s3-vendor');
    var s3c = document.getElementById('skxw-s3-carrier');
    var s3p = document.getElementById('skxw-s3-ship-price');
    if (s3v) s3v.textContent = vendor;

    var rs = window.skxWizardRateSummary || {};
    if (s3c) s3c.textContent = rs.label || '—';
    if (s3p) s3p.textContent = rs.price || '—';

    var chk = document.getElementById('skxw-terms-chk');
    if (chk) chk.checked = false;
    syncRaleCheckbox(false);
    if (typeof window.skxUpdateCheckoutEnabled === 'function') window.skxUpdateCheckoutEnabled();
  }

  var _lbItems = [];
  var _lbIndex = 0;
  var _lbLastFocus = null;

  function bigImage(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, location.origin);
      if (u.searchParams.has('width')) u.searchParams.set('width', String(width));
      else u.searchParams.append('width', String(width));
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function collectItems(vendorName) {
    var items = [];
    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-item[data-vendor-name]'));

    rows.forEach(function (row) {
      var rVendor = row.getAttribute('data-vendor-name') || '';
      if (vendorName && rVendor !== vendorName) return;
      var imgEl   = row.querySelector('.cart-item__image');
      var titleEl = row.querySelector('.cart-item__name');
      var priceEl = row.querySelector('.cart-item__totals.right.small-hide .price--end')
                 || row.querySelector('.price--end');
      var unitEl  = row.querySelector('.product-option');
      var linkEl  = row.querySelector('a.cart-item__name, .cart-item__name a, a.cart-item__link');
      var qty     = parseInt(row.getAttribute('data-qty') || '1', 10) || 1;
      var src     = imgEl ? imgEl.src : '';
      items.push({
        src:       src,
        large:     bigImage(src, 1200),
        title:     titleEl ? titleEl.textContent.trim() : '',
        lineTotal: priceEl ? priceEl.textContent.trim() : '',
        unitPrice: unitEl  ? unitEl.textContent.trim()  : '',
        url:       linkEl && linkEl.getAttribute ? (linkEl.getAttribute('href') || '') : '',
        qty:       qty,
        key:       row.getAttribute('data-line-key') || '',
        vendor:    rVendor
      });
    });

    if (items.length) return items;

    var payloadItems = (typeof window.skxGetCartItems === 'function') ? window.skxGetCartItems() : [];
    var key = (typeof window.skxVendorKey === 'function' && vendorName) ? window.skxVendorKey(vendorName) : '';
    payloadItems.forEach(function (it) {
      if (key && typeof window.skxVendorKey === 'function' && window.skxVendorKey(it.vendor || '') !== key) return;
      var qty = Math.max(1, parseInt(it.quantity, 10) || 1);
      var lineCents = Number(it.line_price_cents || (Number(it.price_cents || 0) * qty));
      items.push({
        src:       it.image || '',
        large:     bigImage(it.image || '', 1200),
        title:     it.product_title || '',
        lineTotal: (typeof window.skxFmtMoney === 'function') ? window.skxFmtMoney(lineCents) : '',
        unitPrice: '',
        url:       it.url || '',
        qty:       qty,
        key:       it.key || it.line_key || '',
        vendor:    it.vendor || vendorName || ''
      });
    });
    return items;
  }

  function buildLightbox() {
    var lb = document.getElementById('skxw-lightbox');
    if (lb) return lb;

    lb = document.createElement('div');
    lb.id = 'skxw-lightbox';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Vista del producto');
    lb.innerHTML =
      '<div class="skxw-lb-panel">' +
        '<button class="skxw-lb-close" type="button" aria-label="Cerrar">✕</button>' +
        '<div class="skxw-lb-stage">' +
          '<button class="skxw-lb-nav skxw-lb-prev" type="button" aria-label="Anterior">‹</button>' +
          '<img alt="">' +
          '<button class="skxw-lb-nav skxw-lb-next" type="button" aria-label="Siguiente">›</button>' +
          '<span class="skxw-lb-count"></span>' +
        '</div>' +
        '<div class="skxw-lb-meta">' +
          '<div class="skxw-lb-title"></div>' +
          '<div class="skxw-lb-facts">' +
            '<span class="skxw-lb-qty"></span>' +
            '<span class="skxw-lb-price"></span>' +
            '<a class="skxw-lb-link" target="_blank" rel="noopener">Ver producto</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(lb);

    lb.querySelector('.skxw-lb-close').addEventListener('click', closeLightbox);
    lb.querySelector('.skxw-lb-prev').addEventListener('click', function () { stepLightbox(-1); });
    lb.querySelector('.skxw-lb-next').addEventListener('click', function () { stepLightbox(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });

    var startX = 0, tracking = false;
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true; startX = e.touches[0].clientX;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = (e.changedTouches[0].clientX - startX);
      if (Math.abs(dx) > 55) stepLightbox(dx < 0 ? 1 : -1);
    }, { passive: true });

    return lb;
  }

  function onLightboxKey(e) {
    if (e.key === 'Escape')     { e.preventDefault(); closeLightbox(); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); stepLightbox(-1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); stepLightbox(1); }
  }

  function paintLightbox() {
    var lb = document.getElementById('skxw-lightbox');
    if (!lb || !_lbItems.length) return;
    var item = _lbItems[_lbIndex];

    var stage = lb.querySelector('.skxw-lb-stage');
    var img   = stage.querySelector('img');
    var empty = stage.querySelector('.skxw-lb-empty');

    if (item.large || item.src) {
      if (empty) empty.remove();
      img.hidden = false;
      img.src = item.large || item.src;
      img.alt = item.title || 'Producto';
    } else {
      img.hidden = true;
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'skxw-lb-empty';
        empty.textContent = '📦';
        stage.appendChild(empty);
      }
    }

    lb.querySelector('.skxw-lb-title').textContent = item.title || 'Producto';

    var qtyEl = lb.querySelector('.skxw-lb-qty');
    qtyEl.textContent = 'Cantidad ×' + item.qty;

    var priceEl = lb.querySelector('.skxw-lb-price');
    priceEl.textContent = item.lineTotal || item.unitPrice || '';

    var linkEl = lb.querySelector('.skxw-lb-link');
    if (item.url) { linkEl.href = item.url; linkEl.hidden = false; }
    else { linkEl.removeAttribute('href'); linkEl.hidden = true; }

    var multi = _lbItems.length > 1;
    lb.querySelector('.skxw-lb-prev').hidden = !multi;
    lb.querySelector('.skxw-lb-next').hidden = !multi;
    var count = lb.querySelector('.skxw-lb-count');
    count.hidden = !multi;
    count.textContent = (_lbIndex + 1) + ' / ' + _lbItems.length;
  }

  function stepLightbox(delta) {
    if (_lbItems.length < 2) return;
    _lbIndex = (_lbIndex + delta + _lbItems.length) % _lbItems.length;
    paintLightbox();
  }

  function openLightbox(index) {
    if (!_lbItems.length) return;
    _lbIndex = Math.max(0, Math.min(index, _lbItems.length - 1));
    var lb = buildLightbox();
    _lbLastFocus = document.activeElement;
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onLightboxKey);
    paintLightbox();
    lb.querySelector('.skxw-lb-close').focus();
  }

  function closeLightbox() {
    var lb = document.getElementById('skxw-lightbox');
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onLightboxKey);
    if (_lbLastFocus && _lbLastFocus.focus) { try { _lbLastFocus.focus(); } catch (e) {} }
    _lbLastFocus = null;
  }

  async function removeOrderItem(item, vendorName, control) {
    if (!item || !item.key) {
      console.warn('[SKX] Cannot remove item: missing cart line key', item);
      return;
    }

    if (control) control.disabled = true;

    try {
      if (typeof window.skxCartUpdate === 'function') {
        await window.skxCartUpdate(item.key, 0, null);
      } else {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var res = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        if (!res.ok) throw new Error('cart/change.js returned ' + res.status);
        var cart = await res.json();
        var nativeRow = document.querySelector('.cart-item[data-line-key="' + CSS.escape(item.key) + '"]');
        if (nativeRow) nativeRow.remove();
        window.dispatchEvent(new CustomEvent('skx:cart-updated', { detail: { cart: cart } }));
      }

      await new Promise(function (resolve) { setTimeout(resolve, 40); });
      var remaining = collectItems(vendorName);

      if (!remaining.length) {
        closeLightbox();
        var vendorCard = document.querySelector('.cart-vendor-card[data-vendor-name="' + CSS.escape(vendorName || '') + '"]');
        if (vendorCard) vendorCard.remove();
        window._skxActiveVendor = '';
        if (typeof window.handleVendorClose === 'function') window.handleVendorClose();
        goStep(0, false);
        return;
      }

      renderVendorProducts(vendorName);
      if (typeof window.handleVendorOpen === 'function') {
        Promise.resolve(window.handleVendorOpen(vendorName)).catch(function () {});
      }
    } catch (err) {
      console.error('[SKX] removeOrderItem failed:', err);
      if (control) control.disabled = false;
      alert('No se pudo eliminar este artículo. Intenta de nuevo.');
    }
  }

  function renderVendorProducts(vendorName) {
    var grid = document.getElementById('skxw-thumb-grid');
    if (!grid) return;
    grid.innerHTML = '';

    var items = collectItems(vendorName);
    _lbItems = items;
    grid.classList.toggle('is-single', items.length === 1);

    var MAX_VISIBLE = 8;
    var visible = items.slice(0, MAX_VISIBLE);
    var overflow = items.length - MAX_VISIBLE;
    var frag = document.createDocumentFragment();

    if (!visible.length) {
      var ph = document.createElement('div');
      ph.className = 'skxw-thumb-placeholder';
      ph.textContent = '🛍';
      frag.appendChild(ph);
    } else {
      visible.forEach(function (item, i) {
        var card = document.createElement('div');
        card.className = 'skxw-thumb-card';

        var wrap = document.createElement('button');
        wrap.type = 'button';
        wrap.setAttribute('aria-label', 'Ver ' + (item.title || 'producto') + ' en grande');
        wrap.addEventListener('click', function () { openLightbox(i); });

        if (item.src) {
          wrap.className = 'skxw-thumb';
          var img = document.createElement('img');
          img.src = item.src;
          img.alt = item.title;
          img.loading = 'lazy';
          wrap.appendChild(img);

          var zoom = document.createElement('span');
          zoom.className = 'skxw-thumb-zoom';
          zoom.textContent = '🔍';
          wrap.appendChild(zoom);

          if (item.qty > 1) {
            var badge = document.createElement('span');
            badge.className = 'skxw-thumb-qty';
            badge.textContent = 'x' + item.qty;
            wrap.appendChild(badge);
          }
          if (item.lineTotal) {
            var priceBadge = document.createElement('span');
            priceBadge.className = 'skxw-thumb-price';
            priceBadge.textContent = item.lineTotal;
            wrap.appendChild(priceBadge);
          }
        } else {
          wrap.className = 'skxw-thumb skxw-thumb-placeholder';
          wrap.textContent = '📦';
        }

        card.appendChild(wrap);

        if (item.key) {
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'skxw-thumb-remove';
          remove.textContent = '−';
          remove.setAttribute('aria-label', 'Eliminar ' + (item.title || 'producto') + ' del carrito');
          remove.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            removeOrderItem(item, vendorName, remove);
          });
          card.appendChild(remove);
        }

        frag.appendChild(card);
      });
    }

    if (overflow > 0) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'skxw-thumb-more';
      more.textContent = '+' + overflow;
      more.setAttribute('aria-label', 'Ver los ' + overflow + ' productos restantes');
      more.addEventListener('click', function () { openLightbox(MAX_VISIBLE); });
      frag.appendChild(more);
    }
    grid.appendChild(frag);

    var detailList = document.getElementById('skxw-product-detail-list');
    if (!detailList) {
      detailList = document.createElement('div');
      detailList.id = 'skxw-product-detail-list';
      grid.parentNode.appendChild(detailList);
    }
    detailList.innerHTML = '';
    items.forEach(function (item, i) {
      var row = document.createElement('div');
      row.className = 'skxw-detail-row';
      row.setAttribute('role', 'button');
      row.tabIndex = 0;
      row.setAttribute('aria-label', 'Ver ' + (item.title || 'producto') + ' en grande');
      row.addEventListener('click', function (ev) {
        if (ev.target && ev.target.closest && ev.target.closest('.skxw-detail-remove')) return;
        openLightbox(i);
      });
      row.addEventListener('keydown', function (ev) {
        if ((ev.key === 'Enter' || ev.key === ' ') && !(ev.target && ev.target.closest && ev.target.closest('.skxw-detail-remove'))) {
          ev.preventDefault();
          openLightbox(i);
        }
      });

      var title = document.createElement('span');
      title.className = 'skxw-detail-title';
      title.textContent = item.title || '—';

      var meta = document.createElement('span');
      meta.className = 'skxw-detail-meta';

      var qty = document.createElement('span');
      qty.className = 'skxw-detail-qty';
      qty.textContent = '×' + item.qty;

      var price = document.createElement('span');
      price.className = 'skxw-detail-price';
      price.textContent = item.lineTotal || item.unitPrice || '—';

      meta.appendChild(qty);
      meta.appendChild(price);

      if (item.key) {
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'skxw-detail-remove';
        remove.textContent = 'Eliminar';
        remove.setAttribute('aria-label', 'Eliminar ' + (item.title || 'producto') + ' del carrito');
        remove.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          removeOrderItem(item, vendorName, remove);
        });
        meta.appendChild(remove);
      }

      row.appendChild(title);
      row.appendChild(meta);
      detailList.appendChild(row);
    });
  }

  function syncShopifyTerms() {
    var shopifyCheckbox = document.querySelector(
      '#skxw-confirm .additional-checkout-buttons input[type="checkbox"], ' +
      '#skxw-confirm .cart__dynamic-checkout-buttons input[type="checkbox"]'
    );
    if (!shopifyCheckbox) return;
    shopifyCheckbox.checked = termsAccepted();
  }

  function setVendorProgress(count) {
    var sub = document.getElementById('skxw-step2-sub');
    if (!sub) return;
    sub.textContent = count > 1
      ? 'Elige una tarifa y paga. Después vuelve por los otros ' + (count - 1) + ' vendedor' + (count - 1 === 1 ? '' : 'es') + '.'
      : 'Elige una tarifa de envío y paga.';
  }

  function init() {
    var slot = document.getElementById('skxw-vendor-slot');
    var groups = document.getElementById('cartGroupsView');

    var shippingPanel = document.getElementById('skxw-p1');
    if (shippingPanel && !shippingPanel.querySelector(':scope > .skxw-p1-scroll')) {
      var shippingHead = shippingPanel.querySelector(':scope > .skxw-panel-head');
      var shippingFooter = shippingPanel.querySelector(':scope > .skxw-footer');
      if (shippingHead && shippingFooter) {
        var shippingScroll = document.createElement('div');
        shippingScroll.className = 'skxw-p1-scroll';
        var node = shippingHead.nextSibling;
        while (node && node !== shippingFooter) {
          var next = node.nextSibling;
          shippingScroll.appendChild(node);
          node = next;
        }
        shippingPanel.insertBefore(shippingScroll, shippingFooter);
      }
    }

    if (groups && !groups.dataset.skxThumbZoomWired) {
      groups.dataset.skxThumbZoomWired = '1';
      groups.addEventListener('click', function (ev) {
        var img = ev.target && ev.target.closest ? ev.target.closest('img') : null;
        if (!img || !groups.contains(img)) return;

        var card = img.closest('.cart-vendor-card, [data-vendor-name], [data-vendor], [data-vendor-key]');
        if (!card) return;

        var vendor = card.getAttribute('data-vendor-name')
          || card.getAttribute('data-vendor')
          || card.getAttribute('data-vendor-key')
          || '';

        if (!vendor) {
          var owner = card.parentElement && card.parentElement.closest
            ? card.parentElement.closest('[data-vendor-name], [data-vendor], [data-vendor-key]')
            : null;
          if (owner) vendor = owner.getAttribute('data-vendor-name') || owner.getAttribute('data-vendor') || owner.getAttribute('data-vendor-key') || '';
        }

        if (!vendor && typeof window.skxVendorNames === 'function') {
          var names = window.skxVendorNames();
          if (names && names.length === 1) vendor = names[0];
        }

        if (!vendor || !window.skxWizard || typeof window.skxWizard.openVendorLightbox !== 'function') return;
        ev.preventDefault();
        ev.stopPropagation();
        window.skxWizard.openVendorLightbox(vendor, img.currentSrc || img.src || '');
      }, true);
    }

    if (slot) {
      if (groups) {
        slot.appendChild(groups);
        groups.style.visibility = 'visible';
        groups.classList.remove('hidden');
        if (typeof window.initVendorCards === 'function') window.initVendorCards();
      } else if (typeof window.generateVendorCards === 'function') {
        window.generateVendorCards(slot);
      }
    }

    var cartItemsSection = document.getElementById('main-cart-items');
    if (cartItemsSection) cartItemsSection.style.display = 'block';

    var vendors = (typeof window.skxVendorNames === 'function') ? window.skxVendorNames() : [];
    setVendorProgress(vendors.length);

    if (vendors.length === 1) {
      _singleVendor = true;
      document.getElementById('skxWizardRoot')?.classList.add('skxw-single');
      selectVendor(vendors[0], { silent: true });
    } else {
      render(false);
    }

    syncShopifyTerms();

    if (window.innerWidth <= 749) {
      setTimeout(function () {
        var target = document.getElementById('skx-mobile-welcome') || document.getElementById('main-cart-footer');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    }
  }

  return {
    goStep: goStep,
    tryGoStep: tryGoStep,
    tryAdvanceFromStep: tryAdvanceFromStep,
    selectVendor: selectVendor,
    onRateSelected: onRateSelected,
    onRateCleared: onRateCleared,
    onTermsChange: onTermsChange,
    termsAccepted: termsAccepted,
    init: init,
    buildConfirmSummary: buildConfirmSummary,
    renderProducts: renderVendorProducts,
    openVendorLightbox: function (vendorName, sourceOrIndex) {
      _lbItems = collectItems(vendorName || '');
      if (!_lbItems.length) return;
      var idx = 0;
      if (typeof sourceOrIndex === 'number') {
        idx = sourceOrIndex;
      } else if (sourceOrIndex) {
        var needle = String(sourceOrIndex).split('?')[0];
        var found = _lbItems.findIndex(function (it) {
          var a = String(it.src || '').split('?')[0];
          var b = String(it.large || '').split('?')[0];
          return a === needle || b === needle || (a && needle.endsWith(a.split('/').pop())) || (needle && a.endsWith(needle.split('/').pop()));
        });
        if (found >= 0) idx = found;
      }
      openLightbox(idx);
    },
    closeLightbox: closeLightbox,
    syncShopifyTerms: syncShopifyTerms,
    isSingleVendor: function () { return _singleVendor; }
  };
})();

(() => {

  const ENVIO_PRODUCT_ID   = 8995224420564;
  const ENVIO_PRODUCT_NAME = 'Envio';
  const ROOT_ID            = 'main-cart-footer';
  const SKX_DEST_KEY       = 'skxDestAddress';
  const SKX_LANG_KEY       = 'skxLangPref';
  const SELECTED_SS_KEY    = 'skxSelectedRatesV1';
  const CART_RESTORE_KEY   = 'skx_cart_restore';
  const MAX_ITEMS_PER_ENVIO = 51;

  const I18N = {
    es: { resultsTitle:'Opciones de envío', resultsSub:'Toca una opción para elegirla.', intlWarning:'⚠️ <strong>Pueden aplicarse costos adicionales</strong> – Gastos de aduana, impuestos o aranceles no están incluidos y deben ser cubiertos por el comprador.', quoteBtn:'Cotizar envío', requoteBtn:'Cotizar de nuevo', quotingBtn:'Cotizando...', changeLbl:'Cambiar', expandBtn:'Ver todas las opciones', toggleFlag:'🇺🇸', toggleLabel:'EN' },
    en: { resultsTitle:'International Shipping', resultsSub:'Tap an option to choose it.', intlWarning:'⚠️ <strong>Additional costs may apply</strong> – Customs fees, taxes or duties are not included and must be covered by the buyer.', quoteBtn:'Get shipping quote', requoteBtn:'Quote again', quotingBtn:'Getting quote...', changeLbl:'Change', expandBtn:'Show all options', toggleFlag:'🇲🇽', toggleLabel:'ES' }
  };

  let skxLang = (() => { try { return localStorage.getItem(SKX_LANG_KEY) === 'en' ? 'en' : 'es'; } catch { return 'es'; } })();
  function t(key) { return I18N[skxLang]?.[key] || I18N.es[key] || key; }

  const selectedRates = new Map();
  let   currentCartItems = [];
  let   _quotingInProgress = false;
  let   _hasQuoted = false;
  let   _quotedSignature = '';
  let   _envioLock = false;
  const _envioQueue = [];
  let   exchangeRates = null;
  let   exchangeRateApiWorking = true;
  let   _cartFetchInFlight = null;
  const _domCache = new Map();
  const _jsonCache = new Map();
  const _fmtCache = new Map();
  let   _totalRafId = null;

  const sleep = ms => new Promise(r => setTimeout(r, ms));
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const getRoot = () => document.getElementById(ROOT_ID);

  function qsR(s) {
    if (_domCache.has(s)) return _domCache.get(s);
    const el = (getRoot() || document).querySelector(s);
    if (el) _domCache.set(s, el);
    return el;
  }
  const clearDomCache = () => { _domCache.clear(); _jsonCache.clear(); };

  const $panel        = () => qsR('#skx-panel');
  const $btn          = () => qsR('#skx-quote-btn');
  const $manualBtn    = () => qsR('#skx-manual-shipping-btn');
  const $resEl        = () => qsR('#skx-results');
  const $emptyEl      = () => qsR('#skx-results-empty');
  const $errEl        = () => qsR('#skx-error');
  const $addrBox      = () => qsR('#skx-addr-box');
  const $destLbl      = () => qsR('#skx-dest-label');
  const $origLbl      = () => qsR('#skx-origins-label');
  const $presetSel    = () => qsR('#skx-preset');
  const $carrierSel   = () => qsR('#skx-carrier');
  const $toCountrySel     = () => qsR('#skx-to-country');
  const $toCountryOtherRow= () => qsR('#skx-to-country-other');
  const $toCountryCodeEl  = () => qsR('#skx-to-country-code');
  const $toZipEl          = () => qsR('#skx-to-zip');
  const $toCityEl         = () => qsR('#skx-to-city');
  const $toStateEl        = () => qsR('#skx-to-state');
  const $toColEl          = () => qsR('#skx-to-colony');
  const $fromVendorsCards = () => qsR('#skx-from-vendors-cards');
  const $checkoutBtn      = () => qsR('#checkout');
  const $cartErrors       = () => qsR('#cart-errors');
  const $selectedSummary  = () => qsR('#skx-selected-summary');
  const $selectedLabel    = () => qsR('#skx-selected-shipping');
  const $clearRatesBtn    = () => qsR('#skx-clear-rates');
  const $destError        = () => qsR('#skx-dest-error');
  const $staleNotice      = () => qsR('#skx-stale-notice');

  function parseJSONText(id, fallback) {
    if (_jsonCache.has(id)) return _jsonCache.get(id);
    try { const raw=(document.querySelector(id)?.textContent||'').trim(); const val=raw?JSON.parse(raw):fallback; _jsonCache.set(id,val); return val; }
    catch { return fallback; }
  }

  function numFromAny(v, fallback=0) {
    if (v==null) return fallback;
    if (typeof v==='number'&&Number.isFinite(v)) return v;
    const raw=String(v).trim(); if (!raw) return fallback;
    const cleaned=raw.replace(/[^0-9.,-]/g,''); let normalized=cleaned;
    if (/,/.test(cleaned)&&/\./.test(cleaned)) normalized=cleaned.replace(/,/g,'');
    else if (/,/.test(cleaned)&&!/\./.test(cleaned)) normalized=cleaned.replace(/\./g,'').replace(',','.');
    const n=Number(normalized); return Number.isFinite(n)?n:fallback;
  }

  const escapeHtml = str => String(str||'').replace(/[&<>]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;'}[m]));
  const vendorKeyFrom = name => String(name||'').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'_').replace(/[^\w@.]/g,'')||'default';

  function getEngine() { const p=$panel(); return (p?.dataset?.engine||'').toLowerCase()||new URL(location.href).searchParams.get('skx_engine')||'pro'; }
  function getApiBase() { return $panel()?.dataset?.apiBase||'/api'; }

  function getEnvioCfg() {
  const ROOT=getRoot();
  return {
    handle:(ROOT?.dataset?.envioProductHandle||'envio').trim().toLowerCase(),
    productIds:String(ROOT?.dataset?.envioProductId||'')
      .split(/[;,\s]+/)
      .map(Number)
      .filter(n=>Number.isFinite(n)&&n>0)
  };
}

  function isEnvioCartItem(li) {
  if (!li) return false;

  const pid=Number(li.product_id||0);
  const title=String(li.product_title||li.title||'').trim();
  const handle=String(li.handle||'').toLowerCase();
  const props=li.properties||{};

  const cfg=getEnvioCfg();

  if (pid===ENVIO_PRODUCT_ID) return true;
  if (title===ENVIO_PRODUCT_NAME) return true;

  if (cfg.productIds.length && cfg.productIds.includes(pid)) return true;

  if (
    cfg.handle &&
    (handle===cfg.handle || handle.includes(cfg.handle))
  ) return true;

  if (
    Object.keys(props).some(
      k=>/^(_skx_is_envio|tarifa|_skx_)/i.test(k)
    )
  ) return true;

  if (/env[ií]o|skydropx/i.test(title)) return true;

  return false;
}

  async function fetchCart() {
    if (_cartFetchInFlight) return _cartFetchInFlight;
    _cartFetchInFlight=fetch(`/cart.js?_=${Date.now()}`,{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>r.json()).finally(()=>{_cartFetchInFlight=null;});
    return _cartFetchInFlight;
  }

  async function purgeAllEnvioLines(maxPasses=6) {
    for (let pass=0;pass<maxPasses;pass++) {
      const cart=await fetchCart(); const envio=(cart.items||[]).filter(li=>isEnvioCartItem(li));
      if (!envio.length) return true;
      const updates={}; envio.forEach(li=>{updates[li.variant_id]=0;});
      await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
      await sleep(400+pass*200);
    }
    const finalCart=await fetchCart(); const remaining=(finalCart.items||[]).filter(li=>isEnvioCartItem(li));
    if (remaining.length) { console.error(`[SKX] PURGE FAILED: ${remaining.length} envio line(s) still present`); return false; }
    return true;
  }

  async function withEnvioLock(fn) {
    if (_envioLock) await new Promise(resolve=>_envioQueue.push(resolve));
    _envioLock=true;
    try { return await fn(); } finally { _envioLock=false; if (_envioQueue.length) _envioQueue.shift()(); }
  }

  const safePurgeEnvio = () => withEnvioLock(()=>purgeAllEnvioLines());

  function getTargetCurrency() { return DEST_COUNTRY()!=='MX'?'USD':'MXN'; }
  function getFmt(currency) {
    if (!_fmtCache.has(currency)) _fmtCache.set(currency,new Intl.NumberFormat(undefined,{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2}));
    return _fmtCache.get(currency);
  }
  const fmtMoney=(cents,cur=null)=>{if(cents==null||cents==='')return'';return getFmt(cur||getTargetCurrency()).format(cents/100);};
  function convertToCurrent(centsMxn) {
    if (getTargetCurrency()==='MXN') return centsMxn;
    if (exchangeRateApiWorking&&exchangeRates?.USD>0) return Math.round((centsMxn/100)*exchangeRates.USD*100);
    return Math.round((centsMxn/100)*0.049*100);
  }

  let _exchangeRateInterval=null,_recoveryAttempts=0;
  const MAX_RECOVERY_ATTEMPTS=5,RECOVERY_INTERVAL_MS=5*60*1000,RATE_REFRESH_MS=30*60*1000;

  async function fetchExchangeRate() {
    try {
      const r=await fetch('https://api.exchangerate-api.com/v4/latest/MXN');
      if (!r.ok) throw new Error(`API ${r.status}`);
      exchangeRates=(await r.json()).rates; exchangeRateApiWorking=true; _recoveryAttempts=0;
      document.getElementById('skx-exchange-rate-warning')?.remove();
    } catch(e) { console.warn('[SKX] Exchange rate error:',e.message); exchangeRateApiWorking=false; showExchangeRateWarning(); }
  }

  function showExchangeRateWarning() {
    if (document.getElementById('skx-exchange-rate-warning')) return;
    const div=document.createElement('div'); div.id='skx-exchange-rate-warning';
    div.innerHTML='<strong>Tipo de cambio no disponible</strong><br>Los precios se muestran en MXN.';
    const resPane=document.getElementById('skx-results-pane');
    if (resPane?.firstChild) resPane.insertBefore(div,resPane.firstChild);
    setTimeout(()=>{div.style.opacity='0';div.style.transition='opacity 0.5s';setTimeout(()=>div.remove(),500);},12000);
  }

  function startExchangeRateRefresh() {
    if (_exchangeRateInterval) clearInterval(_exchangeRateInterval);
    _exchangeRateInterval=setInterval(async()=>{
      await fetchExchangeRate();
      if (exchangeRateApiWorking) {
        document.getElementById('skx-exchange-rate-warning')?.remove();
        const resEl=$resEl();
        if (resEl) {
          const fmt=getFmt(getTargetCurrency());
          resEl.querySelectorAll('.skx-rate--pick').forEach(row=>{
            const rawCents=parseInt(row.dataset.originalCents,10); if(!Number.isFinite(rawCents)||rawCents<=0) return;
            const displayCents=convertToCurrent(rawCents); const priceEl=row.querySelector('.right strong');
            if (priceEl) priceEl.textContent=fmt.format(displayCents/100); row.dataset.cents=String(displayCents);
          });
          computeAndDisplayTotal(); updateSelectedSummaryUI(); refreshConfirmPrice();
        }
      }
    },RATE_REFRESH_MS);
  }

  function scheduleRecovery() {
    if (exchangeRateApiWorking||_recoveryAttempts>=MAX_RECOVERY_ATTEMPTS) return;
    setTimeout(async()=>{_recoveryAttempts++;await fetchExchangeRate();if(exchangeRateApiWorking){document.getElementById('skx-exchange-rate-warning')?.remove();}else if(_recoveryAttempts<MAX_RECOVERY_ATTEMPTS){scheduleRecovery();}},RECOVERY_INTERVAL_MS);
  }

  const __userAddr=()=>parseJSONText('#skx-user-address',null);

  function readDestCountryFromUI() {
    const sel=$toCountrySel(); if (!sel) return '';
    const v=(sel.value||'').toUpperCase();
    if (v==='__OTHER__') { const other=String($toCountryCodeEl()?.value||'').trim().toUpperCase(); return other.length===2?other:''; }
    return v.length===2?v:'';
  }
  const DEST_COUNTRY=()=>{ const ui=readDestCountryFromUI(); if(ui&&ui.length===2)return ui; return String(__userAddr()?.country_code||'MX').trim().toUpperCase().slice(0,2); };

  function validateZipByCountry(zip,cc) {
    const z=String(zip||'').trim(),c=String(cc||'MX').toUpperCase(); if(!z)return false;
    if(c==='MX')return/^\d{5}$/.test(z); if(c==='US')return/^\d{5}(-\d{4})?$/.test(z);
    if(c==='CA')return/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(z);
    return/^[A-Za-z0-9][A-Za-z0-9 \-]{0,10}[A-Za-z0-9]$/.test(z);
  }

  function _addrFromToFields() {
    const zip=($toZipEl()?.value||'').trim(); const city=($toCityEl()?.value||'').trim();
    const state=($toStateEl()?.value||'').trim(); const col=($toColEl()?.value||'').trim();
    const cc=(readDestCountryFromUI()||'MX').trim().toUpperCase().slice(0,2); if(!zip)return null;
    return {country_code:cc,postal_code:zip,...(state?{area_level1:state}:{}),...(city?{area_level2:city}:{}),...(col?{area_level3:col}:{})};
  }

  function destIsQuotable() {
    const cc=DEST_COUNTRY();
    const zip=($toZipEl()?.value||'').trim();
    if(!validateZipByCountry(zip,cc)) return false;
    if(cc==='MX'){
      const city=($toCityEl()?.value||'').trim();
      const state=($toStateEl()?.value||'').trim();
      const colony=($toColEl()?.value||'').trim();
      if(!(city&&state&&colony)) return false;
    }
    return true;
  }

  function destSignature() {
    const a=_addrFromToFields();
    return a?JSON.stringify(a):'';
  }

  function _originsFromCards() {
    const out={};
    qsa('#skx-from-vendors-cards .skx-addr[data-vendor-key]').forEach(card=>{
      const key=card.dataset.vendorKey; const zip=(card.querySelector('.skx-from-zip')?.value||'').trim(); if(!zip)return;
      const city=(card.querySelector('.skx-from-city')?.value||'').trim(); const state=(card.querySelector('.skx-from-state')?.value||'').trim();
      const col=(card.querySelector('.skx-from-colony')?.value||'').trim(); const cc=String(card.dataset.countryCode||'MX').toUpperCase().slice(0,2);
      out[key]={country_code:cc,postal_code:zip,...(state?{area_level1:state}:{}),...(city?{area_level2:city}:{}),...(col?{area_level3:col}:{})};
    });
    return out;
  }

  const labelFromAddr=a=>{const zip=String(a?.postal_code||'').trim();const cc=String(a?.country_code||'').trim().toUpperCase();return cc?`${cc} ${zip||'—'}`:(zip||'—');};

  function saveDestToStorage() {
    try { sessionStorage.setItem(SKX_DEST_KEY,JSON.stringify({country:readDestCountryFromUI(),zip:($toZipEl()?.value||'').trim(),city:($toCityEl()?.value||'').trim(),state:($toStateEl()?.value||'').trim(),colony:($toColEl()?.value||'').trim()})); } catch {}
  }
  function loadDestFromStorage() { try{const r=sessionStorage.getItem(SKX_DEST_KEY);return r?JSON.parse(r):null;}catch{return null;} }
  function restoreDestFromStorage() {
    const saved=loadDestFromStorage(); if(!saved)return false;
    const sel=$toCountrySel();
    if(saved.country&&sel){if(Array.from(sel.options).some(o=>o.value===saved.country))sel.value=saved.country;else{sel.value='__OTHER__';const ce=$toCountryCodeEl();if(ce)ce.value=saved.country;}}
    if(saved.zip&&$toZipEl())$toZipEl().value=saved.zip; if(saved.city&&$toCityEl())$toCityEl().value=saved.city;
    if(saved.state&&$toStateEl())$toStateEl().value=saved.state; if(saved.colony&&$toColEl())$toColEl().value=saved.colony;
    return true;
  }

  function payloadItems() {
    return currentCartItems.length ? currentCartItems : (parseJSONText('#skx-cart-payload',{cart:{items:[]}})?.cart?.items||[]);
  }

  function vendorsInCart() {
    const items=payloadItems();
    const map=new Map(); items.forEach(it=>{const vn=(it?.vendor||'').trim();if(!vn)return;const key=vendorKeyFrom(vn);if(!map.has(key))map.set(key,vn);}); return map;
  }
  function quantityPerVendor() {
    const items=payloadItems();
    const map=new Map(); for(const it of items){const key=vendorKeyFrom(it.vendor||'');const qty=Math.max(1,Math.round(numFromAny(it.quantity,1)));map.set(key,(map.get(key)||0)+qty);} return map;
  }

  const getActiveVendor=()=>(window._skxActiveVendor||'').trim();
  const getActiveVendorKey=()=>vendorKeyFrom(getActiveVendor());

  function saveSelectedToSession(){const obj={};selectedRates.forEach((v,k)=>{obj[k]=v;});try{sessionStorage.setItem(SELECTED_SS_KEY,JSON.stringify(obj));}catch{}}
  function loadSelectedFromSession(){try{const raw=sessionStorage.getItem(SELECTED_SS_KEY);if(!raw)return;const obj=JSON.parse(raw);selectedRates.clear();Object.entries(obj).forEach(([k,v])=>selectedRates.set(k,v));}catch{}}

  const normalizeHs=s=>{if(!s)return null;const cleaned=String(s).trim();if(/^9504\.400000(\d{3})?$/.test(cleaned)||/^9504\.400010$/.test(cleaned))return cleaned;const d=cleaned.replace(/[^\d]/g,'');if(d==='9504400000')return'9504.400000';if(d==='9504400010')return'9504.400010';return'9504.400000';};
  const getDefaultHsCode=()=>normalizeHs(($panel()?.dataset?.defaultHsCode||'').trim())||'9504.400000';

  function sanitizeCartItems(items=[]) {
    const defaultHs=getDefaultHsCode();
    return items.map(it=>{
      const qty=Math.max(1,Math.round(numFromAny(it.quantity,1))); const grams=numFromAny(it.grams,0);
      let priceCents=numFromAny(it.price_cents,NaN);
      if(!Number.isFinite(priceCents))priceCents=Math.round(numFromAny(it.price,0)*100); else priceCents=Math.round(priceCents);
      if(!Number.isFinite(priceCents)||priceCents<=0)priceCents=100;
      const hs=normalizeHs(it.harmonized_code||it.hs_code)||defaultHs;
      return{...it,quantity:qty,grams,price_cents:priceCents,harmonized_code:hs,hs_code:hs};
    });
  }

  async function refreshCartPayloadAndCache() {
    try {
      const freshCart=await fetchCart();
      const freshItems=(freshCart.items||[]).filter(li=>!isEnvioCartItem(li)).map(li=>({vendor:li.vendor||'',quantity:li.quantity,grams:li.grams||0,price_cents:li.final_price||li.price||0,line_price_cents:li.final_line_price||li.line_price||0,product_title:li.product_title||li.title||'',product_id:li.product_id,image:li.image||'',harmonized_code:getDefaultHsCode(),hs_code:getDefaultHsCode()}));
      currentCartItems=freshItems;
      const current=parseJSONText('#skx-cart-payload',{cart:{items:[]}});current.cart.items=freshItems;_jsonCache.set('#skx-cart-payload',current);
    } catch(err){console.warn('[SKX] Failed to refresh cart payload:',err);}
  }

  function readPayload() {
    try {
      const base=parseJSONText('#skx-cart-payload',{cart:{items:[]}});
      const to=_addrFromToFields(); if(to)base.to=to;
      const fromMap=_originsFromCards(); if(Object.keys(fromMap).length)base.from_vendors=fromMap;
      const hints=buildVendorHints(); if(hints.length)base.vendors=hints;
      const preset=$presetSel()?.value; if(preset&&preset!=='__AUTO__')base.preset_key=preset;
      const carrier=$carrierSel()?.value; if(carrier&&carrier!=='__ALL__')base.requested_carriers=[carrier];
      let allItems=Array.isArray(base?.cart?.items)?base.cart.items:[];
      const activeKey=getActiveVendorKey();
      if(activeKey){const filtered=allItems.filter(it=>vendorKeyFrom(it.vendor||'')===activeKey);if(filtered.length)allItems=filtered;}
      base.cart.items=sanitizeCartItems(allItems);
      if(activeKey&&base.from_vendors){const filtered={};for(const[k,v]of Object.entries(base.from_vendors)){const bk=k.replace(/_\d+$/,'');if(bk===activeKey||k===activeKey)filtered[k]=v;}if(Object.keys(filtered).length)base.from_vendors=filtered;}
      const destCC=DEST_COUNTRY();
      if(destCC!=='MX'){base.products=base.cart.items.map(it=>{const qty=Math.max(1,Math.round(numFromAny(it.quantity,1)));const hs=normalizeHs(it.harmonized_code||it.hs_code)||getDefaultHsCode();const desc=String(it.product_title||'').trim()||'Store item';const unitPrice=Math.max(0.01,(numFromAny(it.price_cents,100))/100);return{harmonized_code:hs,hs_code:hs,description_en:desc,country_code:'MX',quantity:qty,unit_price:Number(unitPrice.toFixed(2)),price:Number(unitPrice.toFixed(2)),currency_code:'USD'};});}else{delete base.products;}
      base.engine=String(getEngine()).toLowerCase(); return base;
    } catch(err){console.error('[SKX] readPayload error:',err);return{cart:{items:[]}};}
  }

  const VENDOR_FALLBACK_ORIGINS={'__default':{postal_code:'80260',area_level1:'Sinaloa',area_level2:'Culiacan',area_level3:'Rafael Buelna'}};

  function buildVendorHints() {
    const rows=parseJSONText('#skx-vendor-addresses-from-cart',[]); const hints=new Map();
    (rows||[]).forEach(row=>{const name=String(row?.vendor||'').trim();if(!name)return;const key=vendorKeyFrom(name);const origin=row?.origin?.postal_code?{country_code:row.origin.country_code,postal_code:row.origin.postal_code,area_level1:row.origin.area_level1,area_level2:row.origin.area_level2,area_level3:row.origin.area_level3}:null;const prev=hints.get(key)||{name,key};hints.set(key,{...prev,name,key,origin_hint:prev.origin_hint||origin||null,creator_email:prev.creator_email||String(row?.creator_email||'').trim().toLowerCase()||''});});
    return Array.from(hints.values());
  }

  async function addSingleEnvioLine(vendorKey,rate) {
    const priceCents=Number(rate.originalCentsMxn||rate.cents||0); if(!priceCents)throw new Error('Missing price for envio line');
    const vendorQtyMap=quantityPerVendor(); const vendorQty=vendorQtyMap.get(vendorKey)||1; const multiplier=Math.ceil(vendorQty/MAX_ITEMS_PER_ENVIO); const apiBase=getApiBase();
    const ensureResp=await fetch(`${apiBase}/skydropx/ensure-shipping-variant`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({price_cents:priceCents,currency:'MXN',quantity_required:multiplier})});
    const ensureData=await ensureResp.json(); if(!ensureData.success)throw new Error(ensureData.error||'Variant creation failed'); rate.variantId=ensureData.variant_id;
    const lineItem={id:ensureData.variant_id,quantity:multiplier,properties:{_skx_is_envio:'1',_vendor:vendorKey,_skx_provider:rate.provider||'',_skx_service:rate.service_code||'',_skx_rate_id:rate.rate_id||'',_skx_amount_cents:String(priceCents*multiplier),_skx_item_count:String(vendorQty),_skx_multiplier:String(multiplier),Tarifa:String(priceCents/100)}};
    let addOk=false,addDelay=800;
    for(let attempt=1;attempt<=4;attempt++){
      const addResp=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[lineItem]})});
      if(addResp.ok){addOk=true;break;}
      await addResp.text().catch(()=>''); console.warn(`[SKX] cart/add attempt ${attempt}/4: ${addResp.status}`);
      if(addResp.status===422&&attempt<4){const re=await fetch(`${apiBase}/skydropx/ensure-shipping-variant`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({price_cents:priceCents,currency:'MXN',quantity_required:multiplier})});const rd=await re.json();if(rd.success){lineItem.id=rd.variant_id;rate.variantId=rd.variant_id;}await sleep(addDelay);addDelay=Math.min(addDelay*2,4000);continue;}
      throw new Error(`cart/add failed: ${addResp.status}`);
    }
    if(!addOk)throw new Error('cart/add failed after 4 attempts');
    await sleep(400); await deduplicateEnvioLines(ensureData.variant_id); return ensureData.variant_id;
  }

  async function deduplicateEnvioLines(keepVariantId) {
    const cart=await fetchCart(); const envioLines=(cart.items||[]).filter(li=>isEnvioCartItem(li)); if(envioLines.length<=1)return;
    const updates={}; envioLines.forEach(li=>{if(li.variant_id!==keepVariantId)updates[li.variant_id]=0;});
    if(!Object.keys(updates).length)return;
    await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})}); await sleep(400);
  }

  function getProductSubtotalCents() {
    const activeKey=getActiveVendorKey(); let subtotal=0;
    for(const item of payloadItems()){
      if(activeKey){const itemKey=vendorKeyFrom(item.vendor||'');if(itemKey!==activeKey)continue;}
      subtotal+=numFromAny(item.final_line_price ?? item.line_price ?? item.line_price_cents ?? (numFromAny(item.price_cents,0)*Math.max(1,numFromAny(item.quantity,1))),0);
    }
    return subtotal;
  }

  function computeAndDisplayTotal() {
    if(_totalRafId)cancelAnimationFrame(_totalRafId);
    _totalRafId=requestAnimationFrame(()=>{
      _totalRafId=null; const valueEl=document.getElementById('filtered-totals-value'); if(!valueEl)return;
      const subtotal=getProductSubtotalCents(); const activeKey=getActiveVendorKey(); let shippingCents=0;
      if(activeKey){const rate=selectedRates.get(activeKey);if(rate&&Number(rate.cents)>0){shippingCents=rate.isConverted?Number(rate.cents):convertToCurrent(Number(rate.originalCentsMxn||rate.cents||0));}}
      else{selectedRates.forEach(r=>{shippingCents+=r.isConverted?Number(r.cents||0):convertToCurrent(Number(r.originalCentsMxn||r.cents||0));});}
      valueEl.textContent=fmtMoney(subtotal+shippingCents);
    });
  }

  function refreshConfirmPrice() {
    const activeKey=getActiveVendorKey(); const rate=activeKey?selectedRates.get(activeKey):null;
    const el=document.getElementById('skxw-s3-ship-price'); if(!el||!rate)return;
    const cents=rate.isConverted?Number(rate.cents):convertToCurrent(Number(rate.originalCentsMxn||rate.cents||0));
    el.textContent=fmtMoney(cents);
  }

  function showError(msg){const el=$errEl();if(!el)return;el.textContent=msg||'No pudimos cotizar el envío.';el.hidden=false;const empty=$emptyEl();if(empty)empty.hidden=true;}

  function setEmptyState(html){
    const empty=$emptyEl(); const resEl=$resEl();
    if(!empty)return;
    const hasResults=!!(resEl&&resEl.children.length);
    if(hasResults||html===null){empty.hidden=true;return;}
    empty.innerHTML=html;
    empty.hidden=false;
  }

  function clearUI(){
    const errEl=$errEl();const resEl=$resEl();const loadingEl=document.getElementById('skx-loading');
    if(errEl)errEl.hidden=true;
    if(resEl){resEl.innerHTML='';resEl.style.filter='';resEl.style.pointerEvents='';}
    if(loadingEl)loadingEl.hidden=true;
  }

  function setBusy(on){
    const btn=$btn();const loadingEl=document.getElementById('skx-loading');const resEl=$resEl();const empty=$emptyEl();
    if(loadingEl)loadingEl.hidden=!on;
    if(empty&&on)empty.hidden=true;
    if(btn){btn.disabled=!!on;btn.textContent=on?t('quotingBtn'):(_hasQuoted?t('requoteBtn'):t('quoteBtn'));}
    if(resEl){if(on){resEl.style.filter='blur(3px)';resEl.style.pointerEvents='none';}else{resEl.style.filter='';resEl.style.pointerEvents='';}}
  }

  function vendorsMissingSelection(){const av=getActiveVendor();if(av){const key=getActiveVendorKey();return hasSelectionFor(key)?[]:[key];}return Array.from(vendorsInCart().keys()).filter(k=>!hasSelectionFor(k));}
  function hasSelectionFor(key){
    const r=selectedRates.get(key);
    return !!(r && (r.manualShipping===true || Number(r.cents)>0));
  }

  function updateCheckoutEnabled(){
    const cta=$checkoutBtn();
    const missing=vendorsMissingSelection();
    const hasRate=missing.length===0;
    const accepted=!!(window.skxWizard&&window.skxWizard.termsAccepted&&window.skxWizard.termsAccepted());
    const ok=hasRate&&accepted;
    if(cta){cta.disabled=!ok;cta.setAttribute('aria-disabled',String(!ok));}
    const err=$cartErrors();
    if(err){
      if(ok){err.textContent='';}
      else if(!hasRate){err.textContent=missing.length>1?`Elige un envío para: ${missing.join(', ')}.`:'';}
      else {err.textContent='Acepta los términos para pagar.';}
    }
  }
  window.skxUpdateCheckoutEnabled = updateCheckoutEnabled;

  function updateSelectedSummaryUI(){
    const box=$selectedSummary();const lab=$selectedLabel();if(!box||!lab)return;
    if(_quotingInProgress||!selectedRates.size){box.hidden=true;lab.textContent='—';return;}
    const activeKey=getActiveVendorKey(); const visibleKeys=activeKey?[activeKey]:Array.from(vendorsInCart().keys());
    const entries=[]; let grand=0;
    for(const k of visibleKeys){
      const rate=selectedRates.get(k); if(!rate)continue;
      if(rate.manualShipping===true){entries.push({key:k,manual:true,amt:0});continue;}
      if(!Number(rate.cents))continue;
      const amt=rate.isConverted?Number(rate.cents):convertToCurrent(Number(rate.originalCentsMxn||rate.cents||0));
      entries.push({key:k,manual:false,amt}); grand+=amt;
    }
    if(!entries.length){box.hidden=true;lab.textContent='—';return;}
    const lineFor=(e,prefix='')=>`<span style="display:block;padding:2px 0;">${prefix}${escapeHtml(e.key)}: ${e.manual?'A coordinar con el vendedor':fmtMoney(e.amt)}</span>`;
    if(entries.length===1){lab.innerHTML=lineFor(entries[0]);}
    else{const lines=entries.map((e,i)=>lineFor(e,`${String.fromCharCode(65+i)}.- `)).join('');lab.innerHTML=`${lines}<span style="display:block;margin-top:6px;padding-top:6px;border-top:1px solid rgba(255,255,255,0.08);font-weight:700;">Envío cotizado: ${fmtMoney(grand)}</span>`;}
    box.hidden=false;
  }

  function syncAttrInputs(obj,cents){const selEl=qsR('#attr-skx_selected_rates');const totEl=qsR('#attr-skx_shipping_total_cents');const titEl=qsR('#attr-skx_shipping_title');if(selEl)selEl.value=JSON.stringify(obj||{});if(totEl)totEl.value=String(Number(cents||0));if(titEl)titEl.value='';}

  function syncAttrInputsFromSelection(){
    const payload={};const vendorCounts=quantityPerVendor();let sumMxn=0;
    selectedRates.forEach((v,k)=>{payload[k]=v;const m=Math.ceil((vendorCounts.get(k)||1)/MAX_ITEMS_PER_ENVIO);sumMxn+=Number(v.originalCentsMxn||v.cents||0)*m;});
    syncAttrInputs(payload,sumMxn);
  }

  const SKX_VENDOR_COLOR_CLASSES=['skx-vendor-color-a','skx-vendor-color-b','skx-vendor-color-c','skx-vendor-color-d','skx-vendor-color-e'];
  const skxVendorColorMap=new Map();
  const colorClassForVendor=key=>{const k=key||'default';if(!skxVendorColorMap.has(k))skxVendorColorMap.set(k,SKX_VENDOR_COLOR_CLASSES[skxVendorColorMap.size%SKX_VENDOR_COLOR_CLASSES.length]);return skxVendorColorMap.get(k);};

  function collapseGroupToSelection(group){
    if(!group)return; group.classList.add('has-selection');
    const selRow=group.querySelector('.skx-rate--pick.is-selected');
    if(selRow){
      selRow.classList.remove('skx-rate-hidden-mobile');
      selRow.setAttribute('data-change-label',t('changeLbl'));
    }
    let expandBtn=group.querySelector('.skx-group-expand-btn');
    if(!expandBtn){expandBtn=document.createElement('button');expandBtn.className='skx-group-expand-btn';expandBtn.type='button';expandBtn.textContent=t('expandBtn');expandBtn.addEventListener('click',()=>expandGroup(group));group.appendChild(expandBtn);}
    else{expandBtn.textContent=t('expandBtn');}
  }
  function expandGroup(group){if(group)group.classList.remove('has-selection');}
  function expandAllGroups(){document.querySelectorAll('.skx-group.has-selection').forEach(g=>expandGroup(g));}
  function clearSelectedRatesUI(){
    qsa('.skx-rate--pick.is-selected',$resEl()||document).forEach(el=>{el.classList.remove('is-selected');el.setAttribute('aria-pressed','false');});
    const manual=$manualBtn(); if(manual){manual.classList.remove('is-selected');manual.setAttribute('aria-pressed','false');}
    expandAllGroups();
  }

  function syncManualShippingButtonUI(){
    const btn=$manualBtn(); if(!btn)return;
    const key=getActiveVendorKey(); const rate=key?selectedRates.get(key):null;
    const selected=!!(rate&&rate.manualShipping===true);
    btn.classList.toggle('is-selected',selected);
    btn.setAttribute('aria-pressed',String(selected));
  }

  function selectManualShipping(){
    const vendorKey=getActiveVendorKey(); if(!vendorKey)return;
    const rate={
      cents:0,
      originalCentsMxn:0,
      isConverted:false,
      label:'Yo coordino el envío con el vendedor',
      provider:'Coordinación directa',
      service_code:'MANUAL_VENDOR',
      rate_id:'manual_vendor',
      variantId:null,
      manualShipping:true
    };
    selectedRates.set(vendorKey,rate);
    saveSelectedToSession(); syncAttrInputsFromSelection();
    qsa('.skx-rate--pick.is-selected',$resEl()||document).forEach(el=>{el.classList.remove('is-selected');el.setAttribute('aria-pressed','false');});
    expandAllGroups(); syncManualShippingButtonUI();
    window.skxWizardRateSummary={label:'Yo coordino el envío con el vendedor',price:'A coordinar'};
    updateSelectedSummaryUI(); computeAndDisplayTotal();
    window.skxWizard?.onRateSelected?.(); updateCheckoutEnabled();
  }

  function selectRateRow(row) {
    const resEl=$resEl(); if(!resEl)return;
    const group=row.closest('.skx-group'); const vendorKey=group?.dataset.vendorKey||row.dataset.vendorKey; if(!vendorKey)return;

    const priceCents=Number(row.dataset.originalCents||row.dataset.cents||0);
    const provider=row.dataset.provider||'Carrier';
    const service=row.dataset.service||'';

    const rate={
      cents:Number(row.dataset.cents||0),
      originalCentsMxn:priceCents,
      isConverted:DEST_COUNTRY()!=='MX',
      label:`${provider} · ${service}`.trim(),
      provider,
      service_code:row.dataset.serviceCode||row.dataset.service||'',
      rate_id:row.dataset.rateId||'',
      variantId:null
    };

    selectedRates.set(vendorKey,rate);
    saveSelectedToSession();
    syncAttrInputsFromSelection();

    qsa('.skx-rate--pick',group).forEach(el=>{el.classList.remove('is-selected');el.setAttribute('aria-pressed','false');});
    const manual=$manualBtn(); if(manual){manual.classList.remove('is-selected');manual.setAttribute('aria-pressed','false');}
    row.classList.add('is-selected');
    row.setAttribute('aria-pressed','true');
    collapseGroupToSelection(group);

    window.skxWizardRateSummary={
      label:`${rate.provider}${rate.service_code?' · '+rate.service_code:''}`.trim(),
      price:fmtMoney(rate.isConverted?rate.cents:rate.originalCentsMxn)
    };

    updateSelectedSummaryUI();
    computeAndDisplayTotal();
    window.skxWizard?.onRateSelected?.();
    updateCheckoutEnabled();
  }


  function applyMobileRateLimit(){
    const resEl=$resEl(); if(!resEl)return;
    const mobile=!!(window.matchMedia&&window.matchMedia('(max-width: 749px)').matches);
    qsa('.skx-group',resEl).forEach(group=>{
      const old=group.querySelector('.skx-rates-more-btn');
      if(old)old.remove();
      const rows=qsa('.skx-rate--pick',group);
      rows.forEach(row=>row.classList.remove('skx-rate-hidden-mobile'));
      if(!mobile||rows.length<=5)return;
      rows.slice(5).forEach(row=>row.classList.add('skx-rate-hidden-mobile'));
      const more=document.createElement('button');
      more.type='button';
      more.className='skx-rates-more-btn';
      more.textContent=`Ver más opciones de envío (${rows.length-5})`;
      more.setAttribute('aria-expanded','false');
      more.addEventListener('click',()=>{
        rows.forEach(row=>row.classList.remove('skx-rate-hidden-mobile'));
        more.setAttribute('aria-expanded','true');
        more.remove();
      });
      group.appendChild(more);
    });
  }

  function renderRates(response) {
    const resEl=$resEl(); if(!resEl)return; resEl.innerHTML='';
    if(response?.error==='over_max_tariff'||/No es posible cotizar/i.test(String(response?.message||response?.error||''))){showError(response.message||'No es posible cotizar envío. Contáctanos.');return;}
    const groups=Array.isArray(response?.groups)?response.groups:[];
    if(!groups.length){showError('No recibimos tarifas. Revisa la dirección de destino.');return;}
    try{const to=response?.resolved?.to;const vendors=response?.resolved?.vendors||{};if(to&&$destLbl())$destLbl().textContent=labelFromAddr(to);const originList=Object.entries(vendors).map(([k,v])=>`${k}: ${labelFromAddr(v)}`);if(originList.length&&$origLbl())$origLbl().textContent=originList.join(' · ');if($addrBox())$addrBox().hidden=!(to||originList.length);}catch{}
    const frag=document.createDocumentFragment(); const fmt=getFmt(getTargetCurrency());
    const buildRateRow=(r,vKey)=>{
      const row=document.createElement('div'); row.className='skx-rate skx-rate--pick';
      let rawCents=numFromAny(r.total_cents??r.amount_cents??r.price_cents,NaN); if(!Number.isFinite(rawCents))rawCents=Math.round(numFromAny(r.total??r.amount??r.price,0)*100);else rawCents=Math.round(rawCents);
      const displayCents=DEST_COUNTRY()==='MX'?rawCents:convertToCurrent(rawCents);
      const daysVal=numFromAny(r.days??r.days_estimated??r.delivery_days,NaN); const daysTxt=Number.isFinite(daysVal)?` · ${daysVal} día${daysVal===1?'':'s'}`:'';
      const providerLabel=r.provider_display_name||r.provider_name||r.provider||r.carrier||'Carrier'; const serviceLabel=r.service_display_name||r.service_name||r.service_code||r.service||'';
      row.innerHTML=`<div class="left"><strong>${escapeHtml(providerLabel)}</strong><span>${escapeHtml(serviceLabel)}${daysTxt}</span></div><div class="right"><span class="skx-inline-spinner"></span><strong>${fmt.format(displayCents/100)}</strong></div>`;
      row.dataset.originalCents=String(rawCents);row.dataset.cents=String(displayCents);row.dataset.vendorKey=vKey;row.dataset.provider=providerLabel;row.dataset.service=serviceLabel;row.dataset.serviceCode=r.service_code||r.serviceCode||'';row.dataset.rateId=r.rate_id||r.id||'';
      row.tabIndex=0;row.setAttribute('role','button');row.setAttribute('aria-pressed','false');
      let _touchX=0,_touchY=0,_touchDragged=false;
      row.addEventListener('touchstart',(ev)=>{const t=ev.touches&&ev.touches[0];if(!t)return;_touchX=t.clientX;_touchY=t.clientY;_touchDragged=false;},{passive:true});
      row.addEventListener('touchmove',(ev)=>{const t=ev.touches&&ev.touches[0];if(!t)return;if(Math.hypot(t.clientX-_touchX,t.clientY-_touchY)>10)_touchDragged=true;},{passive:true});
      row.addEventListener('touchend',()=>{if(_touchDragged)return;selectRateRow(row);},{passive:true});
      row.addEventListener('click',(ev)=>{if(ev.detail===0||!('ontouchstart' in window)){ev.preventDefault();selectRateRow(row);}});
      row.addEventListener('keydown',ev=>{if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();selectRateRow(row);}});
      return row;
    };
    groups.forEach(g=>{
      const vKey=g.vendorKey||'vendedor'; const card=document.createElement('div'); card.className=`skx-group ${colorClassForVendor(vKey)}`; card.dataset.vendorKey=vKey;
      const meta=[...(g.engine_used?[String(g.engine_used).toUpperCase()]:[]),...(g.fallback_used?['fallback']:[])];
      card.innerHTML=`<div class="head"><span>${escapeHtml(vKey)}</span><span>${g.from?labelFromAddr(g.from):''}${meta.length?' · '+meta.join(' · '):''}</span></div>`;
      if(g.error&&(!Array.isArray(g.rates)||!g.rates.length)){const err=document.createElement('div');err.className='skx-badge-err';err.textContent=g.error==='missing_hs_code'?'Falta HS válido para envío internacional.':`Error: ${g.error}${g.detail?' – '+(typeof g.detail==='object'?JSON.stringify(g.detail):g.detail):''}`;card.appendChild(err);}
      if(Array.isArray(g.rates)&&g.rates.length){g.rates.forEach(r=>card.appendChild(buildRateRow(r,vKey)));}
      frag.appendChild(card);
    });
    resEl.appendChild(frag);
    applyMobileRateLimit();
    setEmptyState(null);
    applySavedSelectionsToGroups(); computeAndDisplayTotal(); updateCheckoutEnabled();

    setTimeout(() => {
      const resultsPane = document.getElementById('skx-results-pane');
      if (resultsPane) resultsPane.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }, 120);
  }

  function applySavedSelectionsToGroups(){
    if(!selectedRates.size)return; const resEl=$resEl(); if(!resEl)return;
    let restored=false;
    selectedRates.forEach((v,key)=>{
      const group=resEl.querySelector(`.skx-group[data-vendor-key="${key}"]`); if(!group)return;
      const rows=qsa('.skx-rate--pick',group); const rid=v.rate_id||'';
      let found=rid?rows.find(r=>String(r.dataset.rateId||'')===String(rid)):null;
      if(!found)found=rows.find(r=>Number(r.dataset.originalCents||0)===Number(v.originalCentsMxn||v.cents||0)&&(r.dataset.provider||'')===(v.provider||''));
      if(found){found.classList.add('is-selected');found.setAttribute('aria-pressed','true');collapseGroupToSelection(group);restored=true;}
    });
    const activeKey=getActiveVendorKey();const rate=selectedRates.get(activeKey);
    if(rate&&rate.manualShipping===true){
      syncManualShippingButtonUI();
      window.skxWizardRateSummary={label:'Yo coordino el envío con el vendedor',price:'A coordinar'};
      window.skxWizard?.onRateSelected?.();
      return;
    }
    if(restored&&rate){
      window.skxWizardRateSummary={label:`${rate.provider||''}${rate.service_code?' · '+rate.service_code:''}`.trim(),price:fmtMoney(rate.isConverted?rate.cents:rate.originalCentsMxn)};
      window.skxWizard?.onRateSelected?.();
    }
  }

  function openDestAccordion(){
    const header=document.querySelector('#skx-acc-dest .skx-acc-header');
    const body=document.getElementById('skx-acc-dest-body');
    if(header)header.setAttribute('aria-expanded','true');
    if(body)body.hidden=false;
  }

  function showDestError(msg,fields){
    const el=$destError();
    openDestAccordion();
    if(el){el.textContent=msg;el.hidden=false;}
    [$toZipEl(),$toCityEl(),$toStateEl(),$toColEl()].forEach(f=>f&&f.classList.remove('skx-field-error'));
    (fields||[]).forEach(f=>f&&f.classList.add('skx-field-error'));
    const first=(fields||[])[0];
    if(first)setTimeout(()=>{first.scrollIntoView({behavior:'smooth',block:'center'});try{first.focus({preventScroll:true});}catch{}},120);
  }
  function clearDestError(){
    const el=$destError(); if(el){el.hidden=true;el.textContent='';}
    [$toZipEl(),$toCityEl(),$toStateEl(),$toColEl()].forEach(f=>f&&f.classList.remove('skx-field-error'));
  }

  const MAX_QUOTE_RETRIES=2,RETRY_DELAY_MS=1500;
  async function doQuote(isRetry=false,retryCount=0) {
    _quotingInProgress=true;
    if(!isRetry){
      const activeKey=getActiveVendorKey();
      if(activeKey)selectedRates.delete(activeKey); else selectedRates.clear();
      saveSelectedToSession();clearSelectedRatesUI();syncAttrInputsFromSelection();
      window.skxWizard?.onRateCleared?.();
      const box=document.getElementById('skx-selected-summary');const lab=document.getElementById('skx-selected-shipping');
      if(box)box.hidden=true;if(lab)lab.textContent='—';
      clearUI();clearDestError();
      const stale=$staleNotice(); if(stale)stale.hidden=true;
      computeAndDisplayTotal();updateCheckoutEnabled();
      safePurgeEnvio().catch(()=>{});
    }
    setBusy(true);
    try {
      await refreshCartPayloadAndCache();
      const destCC=DEST_COUNTRY(); const toZip=($toZipEl()?.value||__userAddr()?.postal_code||'').trim();
      if(!validateZipByCountry(toZip,destCC)){
        showDestError('Necesitamos un código postal válido para cotizar.',[$toZipEl()]);
        setEmptyState('<span class="skx-empty-icon">📮</span>Agrega tu código postal en <strong>Destino</strong> para ver tarifas.');
        return;
      }
      if(destCC==='MX'){
        const city=($toCityEl()?.value||'').trim();const state=($toStateEl()?.value||'').trim();const colony=($toColEl()?.value||'').trim();
        if(!(city&&state&&colony)){
          const missing=[];if(!city)missing.push($toCityEl());if(!state)missing.push($toStateEl());if(!colony)missing.push($toColEl());
          showDestError('Para México necesitamos Ciudad, Estado y Colonia.',missing);
          setEmptyState('<span class="skx-empty-icon">📮</span>Completa tu dirección en <strong>Destino</strong> para ver tarifas.');
          return;
        }
      }
      clearDestError();
      const payload=readPayload(); if(!payload?.cart?.items?.length){showError('Tu carrito está vacío.');return;}
      const url=`${getApiBase()}/skydropx/quote${getEngine()?`?engine=${encodeURIComponent(getEngine())}`:''}`;
      const resp=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','Accept-Language':navigator.language||'es-MX'},body:JSON.stringify(payload)});
      const data=await resp.json().catch(()=>({}));
      if(!resp.ok){
        const errorMap={
          invalid_lane:data?.message||'Este destino no está soportado.',
          missing_to:'Falta el código postal de destino.',
          missing_from:'Falta el código postal de origen del vendedor.',
          missing_cart_items:'Tu carrito está vacío.',
          over_max_tariff:data?.message||'No es posible cotizar envío. Contáctanos.',
          no_rates:'No hay tarifas disponibles para esta ruta.'
        };
        showError(errorMap[data?.error]||'No pudimos cotizar el envío. Intenta más tarde.');
        return;
      }
      const groups=Array.isArray(data?.groups)?data.groups:[]; const hasAnyRates=groups.some(g=>Array.isArray(g?.rates)&&g.rates.length>0);
      if(!hasAnyRates&&retryCount<MAX_QUOTE_RETRIES){const btn=$btn();if(btn)btn.textContent=`Reintentando (${retryCount+1}/${MAX_QUOTE_RETRIES})...`;await sleep(RETRY_DELAY_MS);return doQuote(true,retryCount+1);}
      if(!hasAnyRates){showError('No se encontraron tarifas para esta ruta.');return;}
      _hasQuoted=true;
      _quotedSignature=destSignature();
      renderRates(data);
    } catch(err){
      console.error('[SKX Quote Error]:',err);
      if(retryCount<MAX_QUOTE_RETRIES){const btn=$btn();if(btn)btn.textContent=`Reintentando (${retryCount+1}/${MAX_QUOTE_RETRIES})...`;await sleep(RETRY_DELAY_MS);return doQuote(true,retryCount+1);}
      showError('Error de red al obtener las tarifas. Revisa tu conexión y cotiza de nuevo.');
    } finally { setTimeout(()=>{_quotingInProgress=false;},800); setBusy(false); }
  }

  let _autoQuoteDone=false;
  window.skxTryAutoQuote=function(){
    if(_quotingInProgress)return;
    const resEl=$resEl();
    if(resEl&&resEl.children.length)return;   // already have rates on screen
    if(!destIsQuotable()){
      setEmptyState('<span class="skx-empty-icon">📮</span>Completa tu dirección en <strong>Destino</strong> y toca <strong>Cotizar envío</strong>.');
      openDestAccordion();
      return;
    }
    if(_autoQuoteDone)return;
    _autoQuoteDone=true;
    setEmptyState('<span class="skx-empty-icon">📦</span>Buscando tarifas para tu dirección…');
    doQuote();
  };

  function invalidateQuoteIfDestChanged(){
    if(!_hasQuoted)return;
    const sig=destSignature();
    if(sig===_quotedSignature)return;
    const stale=$staleNotice(); if(stale)stale.hidden=false;
    const activeKey=getActiveVendorKey();
    if(activeKey)selectedRates.delete(activeKey); else selectedRates.clear();
    saveSelectedToSession();clearSelectedRatesUI();syncAttrInputsFromSelection();
    window.skxWizard?.onRateCleared?.();
    clearUI();
    setEmptyState('<span class="skx-empty-icon">🔄</span>Cambiaste la dirección. Toca <strong>Cotizar de nuevo</strong>.');
    _autoQuoteDone=false;
    updateSelectedSummaryUI();computeAndDisplayTotal();updateCheckoutEnabled();
    const btn=$btn(); if(btn&&!btn.disabled)btn.textContent=t('requoteBtn');
  }

  function wireCheckoutButton(){
    const checkoutBtn=$checkoutBtn(); if(!checkoutBtn||checkoutBtn._skxWired)return; checkoutBtn._skxWired=true;
    const paySteps=['Generando compra','Verificando inventario','Preparando envío','Terminando…']; let _payStepTimer=null;
    function startPayAnimation(){checkoutBtn.classList.add('skx-paying');const label=document.getElementById('skx-pay-label');let idx=0;if(label)label.textContent=paySteps[0];_payStepTimer=setInterval(()=>{idx=Math.min(idx+1,paySteps.length-1);if(label){label.style.opacity='0';label.style.transition='opacity 0.2s';setTimeout(()=>{label.textContent=paySteps[idx];label.style.opacity='1';},180);}if(idx===paySteps.length-1)clearInterval(_payStepTimer);},900);}
    function stopPayAnimation(restoreText){clearInterval(_payStepTimer);checkoutBtn.classList.remove('skx-paying');const label=document.getElementById('skx-pay-label');if(label)label.textContent=restoreText;}

    checkoutBtn.onclick=async e=>{
      e.preventDefault();
      const missing=vendorsMissingSelection();
      if(missing.length||!window.skxWizard?.termsAccepted?.()){updateCheckoutEnabled();return;}

      const activeVendor=getActiveVendor(); const activeKey=activeVendor?vendorKeyFrom(activeVendor):null;
      const origText=document.getElementById('skx-pay-label')?.textContent||'Checkout';
      checkoutBtn.disabled=true; startPayAnimation();

      const isMobile=/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        || (navigator.maxTouchPoints > 1 && /Mac/i.test(navigator.platform))
        || window.innerWidth <= 749;
      let overlay=null;
      if(isMobile){
        overlay=document.createElement('div');overlay.id='_skx_mobile_overlay';
        overlay.innerHTML=`<div class="_skx_spin"></div><div class="_skx_title">Preparando tu pedido<span class="_skx_dot">.</span><span class="_skx_dot">.</span><span class="_skx_dot">.</span></div><div class="_skx_sub">Estamos confirmando tu envío y abriendo el checkout.</div>`;
        overlay.style.position='fixed';overlay.style.top='0';overlay.style.left='0';overlay.style.right='0';overlay.style.bottom='0';
        overlay.style.zIndex='2147483647';overlay.style.background=getComputedStyle(document.documentElement).getPropertyValue('--tcg-black')||'#080b0b';
        overlay.style.display='flex';overlay.style.flexDirection='column';overlay.style.alignItems='center';overlay.style.justifyContent='center';
        overlay.style.gap='28px';overlay.style.padding='40px';
        document.body.appendChild(overlay);
        overlay.getBoundingClientRect();
      }

      try {
        const fullCart=await fetchCart(); const nonEnvioItems=(fullCart.items||[]).filter(li=>!isEnvioCartItem(li));
        const otherGroupItems=nonEnvioItems.filter(li=>!activeKey||vendorKeyFrom(li.vendor||'')!==activeKey);
        if(otherGroupItems.length){sessionStorage.setItem(CART_RESTORE_KEY,JSON.stringify(otherGroupItems.map(li=>({id:li.variant_id,quantity:li.quantity,properties:li.properties||{}}))));}else{sessionStorage.removeItem(CART_RESTORE_KEY);}

        const purgeOk=await withEnvioLock(()=>purgeAllEnvioLines(8)); if(!purgeOk)throw new Error('cart_purge_failed');

        if(activeKey){const hideUpdates={};nonEnvioItems.forEach(li=>{if(vendorKeyFrom(li.vendor||'')!==activeKey)hideUpdates[li.variant_id]=0;});if(Object.keys(hideUpdates).length){await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:hideUpdates})});await sleep(600);}}

        const preAdd=await fetchCart(); const preEnvios=(preAdd.items||[]).filter(li=>isEnvioCartItem(li));
        if(preEnvios.length){const emergency={};preEnvios.forEach(li=>{emergency[li.variant_id]=0;});await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:emergency})});await sleep(600);}

        const rate=activeKey?selectedRates.get(activeKey):null; if(!rate)throw new Error('No shipping option selected');
        const isManualShipping=rate.manualShipping===true;
        let variantId=null;

        if(!isManualShipping){
          variantId=await withEnvioLock(()=>addSingleEnvioLine(activeKey,rate)); rate.variantId=variantId; selectedRates.set(activeKey,rate);
          await sleep(300);

          const postCart=await fetchCart(); const postEnvios=(postCart.items||[]).filter(li=>isEnvioCartItem(li));
          if(postEnvios.length>1){const dedupUpdates={};postEnvios.forEach(li=>{if(li.variant_id!==variantId)dedupUpdates[li.variant_id]=0;});if(Object.keys(dedupUpdates).length){await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:dedupUpdates})});await sleep(400);}}
        }

        const attrsPayload={};if(activeKey)attrsPayload[activeKey]=rate;
        await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{skx_selected_rates:JSON.stringify(attrsPayload),skx_shipping_total_cents:String(isManualShipping?0:Number(rate.originalCentsMxn||rate.cents||0)),skx_shipping_title:isManualShipping?'Yo coordino el envío con el vendedor':'',skx_active_vendor:activeKey||''}})});
        await sleep(200); sessionStorage.setItem(CART_RESTORE_KEY+'_flag','1');
        if(overlay)setTimeout(()=>{overlay.style.opacity='0.6';},100);

        const shopifyCheckbox=document.querySelector(
          '#skxw-confirm .additional-checkout-buttons input[type="checkbox"], ' +
          '#skxw-confirm .cart__dynamic-checkout-buttons input[type="checkbox"]'
        );
        if(shopifyCheckbox)shopifyCheckbox.checked=true;

        location.href='/checkout';
      } catch(err){
        console.error('[SKX] Checkout error:',err); if(overlay)overlay.remove();
        try{const restoreRaw=sessionStorage.getItem(CART_RESTORE_KEY);if(restoreRaw){const items=JSON.parse(restoreRaw);if(items.length){await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});}sessionStorage.removeItem(CART_RESTORE_KEY);}}catch{}
        safePurgeEnvio().catch(()=>{});
        const errBox=$cartErrors();if(errBox)errBox.textContent='No pudimos abrir el checkout. Intenta de nuevo.';
        stopPayAnimation(origText); checkoutBtn.disabled=false;
      }
    };
  }

  function wireClearRatesButton(){
    const btn=$clearRatesBtn();if(!btn||btn._skxWired)return;btn._skxWired=true;
    btn.onclick=()=>{clearRatesAndEnvio();};
  }

  window.addEventListener('pageshow',async()=>{
    clearDomCache(); try{await safePurgeEnvio();}catch{}
    const restoreRaw=sessionStorage.getItem(CART_RESTORE_KEY);
    if(restoreRaw){
      try{
        const items=JSON.parse(restoreRaw);sessionStorage.removeItem(CART_RESTORE_KEY);
        if(Array.isArray(items)&&items.length){
          const liveCart=await fetchCart();const currentIds=new Set((liveCart.items||[]).map(li=>li.variant_id));
          const toAdd=items.filter(it=>{if(Number(it.id)===ENVIO_PRODUCT_ID)return false;if(it.properties&&(it.properties._skx_is_envio==='1'||it.properties.Tarifa))return false;if(currentIds.has(it.id))return false;return true;});
          if(toAdd.length){await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:toAdd})});await sleep(500);const fresh=await fetchCart();currentCartItems=(fresh.items||[]).filter(li=>!isEnvioCartItem(li));window.location.reload();return;}
        }
      }catch(err){console.warn('[SKX] pageshow restore failed:',err);sessionStorage.removeItem(CART_RESTORE_KEY);}
    }
    const cameFromCheckout=!!sessionStorage.getItem(CART_RESTORE_KEY+'_flag'); sessionStorage.removeItem(CART_RESTORE_KEY+'_flag');
    if(cameFromCheckout){selectedRates.clear();sessionStorage.removeItem(SELECTED_SS_KEY);saveSelectedToSession();clearSelectedRatesUI();window.skxWizard?.onRateCleared?.();}
    else{loadSelectedFromSession();}
    const freshCart=await fetchCart();currentCartItems=(freshCart.items||[]).filter(li=>!isEnvioCartItem(li));
    updateSelectedSummaryUI();syncAttrInputsFromSelection();syncManualShippingButtonUI();updateCheckoutEnabled();computeAndDisplayTotal();
    const activeRate=selectedRates.get(getActiveVendorKey());
    if(activeRate?.manualShipping===true){window.skxWizardRateSummary={label:'Yo coordino el envío con el vendedor',price:'A coordinar'};window.skxWizard?.onRateSelected?.();}
    window.skxWizard?.syncShopifyTerms?.();
    document.getElementById('_skx_mobile_overlay')?.remove();
  });

  function filterVendorOriginCards(activeVendorName){
    const container=document.getElementById('skx-from-vendors-cards');if(!container)return;
    const activeKey=activeVendorName?vendorKeyFrom(activeVendorName):'';
    qsa('.skx-addr[data-vendor-key]',container).forEach(card=>{const baseKey=(card.dataset.vendorKey||'').replace(/_\d+$/,'');const show=!activeVendorName||baseKey===activeKey||card.dataset.vendorKey===activeKey;card.style.display=show?'':'none';card.classList.toggle('vendor-hidden',!show);});
    const nameRow=document.getElementById('skx-active-vendor-name-row');
    const nameLbl=document.getElementById('skx-active-vendor-name-label');
    if(nameRow)nameRow.classList.toggle('is-visible',!!activeVendorName);
    if(nameLbl)nameLbl.textContent=activeVendorName||'—';
  }

  window.handleVendorOpen=async function(vendorName){
    await refreshCartPayloadAndCache();
    filterVendorOriginCards(vendorName);updateAccordionSummaries();syncAddrSummaryFromFields();updateMissingOriginsWarning();
    clearUI();clearSelectedRatesUI();syncManualShippingButtonUI();updateSelectedSummaryUI();computeAndDisplayTotal();updateCheckoutEnabled();
    const activeRate=selectedRates.get(getActiveVendorKey());
    if(activeRate?.manualShipping===true){window.skxWizardRateSummary={label:'Yo coordino el envío con el vendedor',price:'A coordinar'};window.skxWizard?.onRateSelected?.();}
    safePurgeEnvio().catch(()=>{});
    window.dispatchEvent(new CustomEvent('vendorSelectedForShipping',{detail:{vendor:vendorName||''}}));
  };
  window.handleVendorClose=async function(){
    await refreshCartPayloadAndCache();
    filterVendorOriginCards('');updateAccordionSummaries();clearUI();updateSelectedSummaryUI();computeAndDisplayTotal();updateCheckoutEnabled();
    safePurgeEnvio().catch(()=>{});
    window.dispatchEvent(new CustomEvent('vendorSelectedForShipping',{detail:{vendor:''}}));
  };

  function initAccordions(){
    document.querySelectorAll('.skx-acc-header').forEach(btn=>{
      if(btn._accWired)return;btn._accWired=true;
      const bodyId=btn.getAttribute('aria-controls');const body=bodyId?document.getElementById(bodyId):null;if(!body)return;
      btn.addEventListener('click',()=>{const isOpen=btn.getAttribute('aria-expanded')==='true';btn.closest('#skx-panel')?.querySelectorAll('.skx-acc-header').forEach(other=>{if(other===btn)return;const otherId=other.getAttribute('aria-controls');const otherBody=otherId?document.getElementById(otherId):null;other.setAttribute('aria-expanded','false');if(otherBody)otherBody.hidden=true;});btn.setAttribute('aria-expanded',String(!isOpen));body.hidden=isOpen;});
    });
  }

  function updateAccordionSummaries(){
    const destSummary=document.getElementById('skx-dest-summary');
    if(destSummary){
      const zip=($toZipEl()?.value||'').trim();const city=($toCityEl()?.value||'').trim();const state=($toStateEl()?.value||'').trim();const cc=readDestCountryFromUI()||'MX';
      const parts=[zip,city,state,cc!=='MX'?cc:''].filter(Boolean);
      const complete=destIsQuotable();
      destSummary.textContent=parts.length&&zip?parts.join(', '):'Falta tu dirección';
      destSummary.classList.toggle('has-value',complete);
      destSummary.classList.toggle('needs-value',!complete);
    }
    const vendorSummary=document.getElementById('skx-vendor-summary');
    if(vendorSummary){const av=getActiveVendor();if(av){vendorSummary.textContent=av;vendorSummary.classList.add('has-value');}else{const cnt=vendorsInCart().size;vendorSummary.textContent=cnt?`${cnt} vendedor${cnt!==1?'es':''}`:'—';vendorSummary.classList.toggle('has-value',cnt>0);}}
    const pkgSummary=document.getElementById('skx-pkg-summary');
    if(pkgSummary){const presetEl=$presetSel();const carrierEl=$carrierSel();const presetTxt=presetEl?(presetEl.options[presetEl.selectedIndex]?.text||'Auto'):'Auto';const carrierTxt=carrierEl&&carrierEl.value!=='__ALL__'?carrierEl.value:'Todos';pkgSummary.textContent=`${presetTxt} · ${carrierTxt}`;pkgSummary.classList.add('has-value');}
  }

  function syncAddrSummaryFromFields(){
    const addrBox=$addrBox(),destLbl=$destLbl(),origLbl=$origLbl();if(!addrBox||!destLbl||!origLbl)return;
    const dest=_addrFromToFields();const origins=_originsFromCards();const hasOrig=Object.keys(origins).length>0;
    destLbl.textContent=dest?labelFromAddr(dest):'—';origLbl.textContent=hasOrig?Object.entries(origins).map(([k,v])=>`${k}: ${labelFromAddr(v)}`).join(' · '):'—';addrBox.hidden=!(dest||hasOrig);
  }

  function updateMissingOriginsWarning(){
    const panel=$panel();const cardsRoot=$fromVendorsCards();if(!panel||!cardsRoot)return;
    const allCardKeys=Array.from(cardsRoot.querySelectorAll('.skx-addr[data-vendor-key]')).map(c=>c.dataset.vendorKey);
    const activeKey=getActiveVendorKey();
    const keysToCheck=activeKey?[activeKey]:Array.from(vendorsInCart().keys());
    const missing=keysToCheck.filter(k=>{const card=cardsRoot.querySelector(`.skx-addr[data-vendor-key="${k}"]`);const check=c=>{if(!c)return true;return!(c.querySelector('.skx-from-zip')?.value?.trim()&&c.querySelector('.skx-from-city')?.value?.trim()&&c.querySelector('.skx-from-state')?.value?.trim()&&c.querySelector('.skx-from-colony')?.value?.trim());};if(card)return check(card);const fuzzy=allCardKeys.find(ck=>ck.replace(/_\d+$/,'')===k);return check(fuzzy?cardsRoot.querySelector(`.skx-addr[data-vendor-key="${fuzzy}"]`):null);});
    let warn=document.getElementById('skx-missing-origins');
    if(missing.length){if(!warn){warn=document.createElement('div');warn.id='skx-missing-origins';warn.className='skx-badge-err';panel.querySelector('.skx-actions')?.before(warn);}warn.textContent=`Este vendedor no tiene dirección de origen completa: ${missing.join(', ')}.`;}else{warn?.remove();}
  }

  function debounce(fn,ms){let t;return(...args)=>{clearTimeout(t);t=setTimeout(()=>fn(...args),ms);};}
  function syncCountryUI(){const sel=$toCountrySel();const otherRow=$toCountryOtherRow();const v=String(sel?.value||'').toUpperCase();if(otherRow)otherRow.hidden=v!=='__OTHER__';}

  function displayCustomerAddressSummary(){
    const el=document.getElementById('skx-customer-address-summary');if(!el)return;
    const zip=($toZipEl()?.value||'').trim();if(!zip){el.hidden=true;return;}
    const city=($toCityEl()?.value||'').trim(),state=($toStateEl()?.value||'').trim(),colony=($toColEl()?.value||'').trim();
    const cc=DEST_COUNTRY();const isMx=cc==='MX';const ok=isMx?(city&&state&&colony):true;
    const addr=[city,state,zip,colony].filter(Boolean).join(', ')||'Dirección incompleta';
    const countryNames={MX:'México',US:'Estados Unidos',CA:'Canadá',ES:'España',CO:'Colombia',FR:'Francia',GB:'Reino Unido',CN:'China'};
    if(!ok){
      el.innerHTML=`<div style="background:rgba(255,45,58,0.07);border-left:3px solid var(--tcg-red);padding:8px 12px;margin-bottom:12px;color:rgba(255,45,58,0.9);font-size:12px;"><strong>Falta información</strong><br>${!zip?'• Código postal<br>':''}${isMx&&!city?'• Ciudad<br>':''}${isMx&&!state?'• Estado<br>':''}${isMx&&!colony?'• Colonia<br>':''}</div>`;
    } else {
      el.innerHTML=`<div><strong>📬 ${escapeHtml(addr)}</strong><br>${escapeHtml(countryNames[cc]||cc)} (${escapeHtml(cc)})</div>`;
    }
    el.hidden=false;
  }

  function updateMexicoWarning(){const el=document.getElementById('skx-mexico-warning');if(!el)return;if(DEST_COUNTRY()!=='MX'){el.style.display='none';return;}const city=($toCityEl()?.value||'').trim(),state=($toStateEl()?.value||'').trim(),colony=($toColEl()?.value||'').trim();el.style.display=!(city&&state&&colony)?'flex':'none';}

  function bindDestInputListeners(){
    const debouncedUpdate=debounce(()=>{
      syncCountryUI();updateMexicoWarning();displayCustomerAddressSummary();syncAddrSummaryFromFields();
      updateMissingOriginsWarning();updateIntlWarning();updateIntlPaneState();saveDestToStorage();updateAccordionSummaries();
      invalidateQuoteIfDestChanged();
    },400);
    [$toZipEl(),$toCityEl(),$toStateEl(),$toColEl(),$toCountryCodeEl()].forEach(el=>{ if(el) el.oninput=debouncedUpdate; });
    const cSel=$toCountrySel();
    if(cSel)cSel.onchange=()=>{
      syncCountryUI();updateMexicoWarning();displayCustomerAddressSummary();saveDestToStorage();updateAccordionSummaries();
      updateIntlWarning();updateIntlPaneState();clearRatesAndEnvio();
      if(String(cSel.value).toUpperCase()==='__OTHER__'){setTimeout(()=>{ $toCountryCodeEl()?.focus(); },80);}
    };
  }

  function clearRatesAndEnvio(){
    const activeKey=getActiveVendorKey();
    if(activeKey)selectedRates.delete(activeKey); else selectedRates.clear();
    saveSelectedToSession();clearSelectedRatesUI();updateSelectedSummaryUI();syncAttrInputsFromSelection();
    window.skxWizard?.onRateCleared?.();
    updateCheckoutEnabled();computeAndDisplayTotal();clearUI();
    _autoQuoteDone=false;
    setEmptyState('<span class="skx-empty-icon">🔄</span>Toca <strong>Cotizar envío</strong> para ver tarifas.');
    safePurgeEnvio().catch(()=>{});
  }

  function deduplicateVendorRows(rows){
    const seen=new Map();const result=[];
    for(const row of rows){const key=vendorKeyFrom(row.vendor);const qty=Number(row.quantity||1);if(!seen.has(key)){seen.set(key,{totalQty:qty});result.push({...row,_key:key});}else seen.get(key).totalQty+=qty;}
    return result.map(r=>{const totalQty=seen.get(r._key)?.totalQty||Number(r.quantity||1);const slots=Math.ceil(totalQty/MAX_ITEMS_PER_ENVIO);return{...r,_totalQty:totalQty,_slots:slots};});
  }

  async function buildVendorFormsAndPrefill(){
    const cardsRoot=$fromVendorsCards();if(!cardsRoot)return;cardsRoot.innerHTML='';
    const vendorDataRaw=parseJSONText('#skx-vendor-addresses-from-cart',[]);const frag=document.createDocumentFragment();
    if(!vendorDataRaw?.length){const card=document.createElement('div');card.className='skx-addr';card.dataset.vendorKey='default';card.dataset.countryCode='MX';card.innerHTML=`<div style="font-weight:500;">📍 Vendedor</div><input class="skx-from-zip" type="text" value="" placeholder="Código postal" hidden><input class="skx-from-state" type="text" value="" placeholder="Estado" hidden><input class="skx-from-city" type="text" value="" placeholder="Ciudad" hidden><input class="skx-from-colony" type="text" value="" placeholder="Colonia" hidden>`;frag.appendChild(card);}
    else{
      const deduped=deduplicateVendorRows(vendorDataRaw);
      deduped.forEach(vendor=>{
        const vendorKey=vendorKeyFrom(vendor.vendor);const origin=vendor.origin||{};const fallback=VENDOR_FALLBACK_ORIGINS[vendorKey]||VENDOR_FALLBACK_ORIGINS['__default']||{};const slots=vendor._slots||1;
        for(let slot=0;slot<slots;slot++){
          const slotKey=slots>1?`${vendorKey}_${slot+1}`:vendorKey;const slotLabel=slots>1?`${vendor.vendor} (envío ${slot+1} de ${slots})`:vendor.vendor;
          const card=document.createElement('div');card.className='skx-addr';card.dataset.vendorKey=slotKey;card.dataset.countryCode=origin.country_code||'MX';
          card.innerHTML=`<div style="font-weight:800;color:var(--tcg-text);">📍 ${escapeHtml(slotLabel)}</div><input class="skx-from-zip" type="text" value="${escapeHtml(origin.postal_code||fallback.postal_code||'')}" placeholder="Código postal" hidden><input class="skx-from-state" type="text" value="${escapeHtml(origin.area_level1||fallback.area_level1||'')}" placeholder="Estado" hidden><input class="skx-from-city" type="text" value="${escapeHtml(origin.area_level2||fallback.area_level2||'')}" placeholder="Ciudad" hidden><input class="skx-from-colony" type="text" value="${escapeHtml(origin.area_level3||fallback.area_level3||'')}" placeholder="Colonia" hidden>`;
          frag.appendChild(card);
        }
      });
    }
    cardsRoot.appendChild(frag);filterVendorOriginCards(getActiveVendor());updateAccordionSummaries();syncAddrSummaryFromFields();updateMissingOriginsWarning();
  }

  async function prefillOriginsFromBackend(){
    try{const cardsRoot=$fromVendorsCards();if(!cardsRoot)return;const items=parseJSONText('#skx-cart-products',[]);if(!Array.isArray(items)||!items.length)return;const r=await fetch(`${getApiBase()}/cart/vendor-origins`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const j=await r.json().catch(()=>({}));if(!r.ok||!j?.success||!j?.vendors)return;qsa('.skx-addr[data-vendor-key]',cardsRoot).forEach(card=>{const baseKey=card.dataset.vendorKey.replace(/_\d+$/,'');const o=j.vendors[baseKey];if(!o?.postal_code)return;if(o.country_code)card.dataset.countryCode=String(o.country_code).toUpperCase().slice(0,2);const zipEl=card.querySelector('.skx-from-zip');const cityEl=card.querySelector('.skx-from-city');const stateEl=card.querySelector('.skx-from-state');const colEl=card.querySelector('.skx-from-colony');if(!zipEl.value&&o.postal_code)zipEl.value=o.postal_code;if(!cityEl.value&&o.area_level2)cityEl.value=o.area_level2;if(!stateEl.value&&o.area_level1)stateEl.value=o.area_level1;if(!colEl.value&&o.area_level3)colEl.value=o.area_level3;});}catch{}
  }

  let _optionsLoaded=false;
  async function fetchSkxOptionsAndPopulate(){
    if(_optionsLoaded)return; _optionsLoaded=true;
    const presetSel=$presetSel();const carrierSel=$carrierSel();
    const fallbackPresets=[{key:'envelope_30x45x5_1kg',label:'Sobre 30×45×5 · 1kg'},{key:'parcel_40x30x20_3kg',label:'Paquete 40×30×20 · 3kg'},{key:'parcel_60x40x40_8kg',label:'Paquete 60×40×40 · 8kg'},{key:'box_80x60x60_15kg',label:'Caja 80×60×60 · 15kg'}];
    const populatePresets=presets=>{if(!presetSel)return;presetSel.innerHTML='<option value="__AUTO__">Auto (por artículo)</option>';presets.forEach(p=>{const opt=document.createElement('option');opt.value=p.key;opt.textContent=p.label||p.key;presetSel.appendChild(opt);});const envOpt=Array.from(presetSel.options).find(o=>/sobre|envelope/i.test(o.textContent||''));if(envOpt)presetSel.value=envOpt.value;};
    try{const r=await fetch(`${getApiBase()}/skydropx/options${getEngine()?`?engine=${encodeURIComponent(getEngine())}`:''}`,{headers:{Accept:'application/json'}});const j=await r.json().catch(()=>({}));populatePresets(Array.isArray(j?.parcel_presets)?j.parcel_presets:fallbackPresets);}catch{populatePresets(fallbackPresets);}
    if(carrierSel)carrierSel.innerHTML='<option value="__ALL__">Todos</option>';
  }

  function bindSelectEvents(){
    const presetEl=$presetSel();const carrierEl=$carrierSel();
    const trigger=()=>{
      updateAccordionSummaries();
      const isEmpty=getRoot()?.classList.contains('is-empty');
      if(destIsQuotable()&&!isEmpty&&!_quotingInProgress)doQuote();
    };
    [presetEl,carrierEl].forEach(el=>{if(!el||el._selectWired)return;el._selectWired=true;el.addEventListener('change',e=>{e.stopPropagation();trigger();});});
  }

  function prefillDestinationFromCustomer(){
    if(restoreDestFromStorage()){syncCountryUI();return;}
    const user=__userAddr();if(!user||!user.postal_code)return;
    const zipEl=$toZipEl(),cityEl=$toCityEl(),stateEl=$toStateEl(),colEl=$toColEl(),countrySel=$toCountrySel();
    if(user.postal_code&&zipEl&&!zipEl.value)zipEl.value=user.postal_code;if(user.area_level2&&cityEl&&!cityEl.value)cityEl.value=user.area_level2;if(user.area_level1&&stateEl&&!stateEl.value)stateEl.value=user.area_level1;if(user.area_level3&&colEl&&!colEl.value)colEl.value=user.area_level3;
    if(countrySel&&user.country_code){const cc=user.country_code.toUpperCase();if(Array.from(countrySel.options).some(o=>o.value===cc))countrySel.value=cc;else if(cc!=='MX'){countrySel.value='__OTHER__';const ce=$toCountryCodeEl();if(ce)ce.value=cc;}}
    syncCountryUI();updateMexicoWarning();displayCustomerAddressSummary();
  }

  function showEdgeWarning(){const w=document.getElementById('skx-edge-warning');if(!w)return;const ua=navigator.userAgent.toLowerCase();const isEdge=ua.includes('edg')||ua.includes('edge');w.hidden=!isEdge;if(isEdge){const c=w.querySelector('.close-warning');if(c)c.onclick=()=>{w.hidden=true;};}}

  function initLangToggle(){const btn=document.getElementById('skx-lang-toggle');if(!btn||btn._skxLangWired)return;btn._skxLangWired=true;btn.addEventListener('click',()=>{skxLang=skxLang==='es'?'en':'es';try{localStorage.setItem(SKX_LANG_KEY,skxLang);}catch{}applyLangToPane();});}

  function applyLangToPane(){
    const titleEl=document.getElementById('skx-results-pane-title');const subEl=document.getElementById('skx-results-pane-sub');const toggleBtn=document.getElementById('skx-lang-toggle');const isIntl=DEST_COUNTRY()!=='MX';
    if(titleEl)titleEl.textContent=isIntl&&skxLang==='en'?t('resultsTitle'):'Opciones de envío';if(subEl)subEl.textContent=t('resultsSub');
    if(toggleBtn){toggleBtn.querySelector('.lang-flag').textContent=skxLang==='es'?I18N.es.toggleFlag:I18N.en.toggleFlag;toggleBtn.querySelector('.lang-label').textContent=skxLang==='es'?I18N.es.toggleLabel:I18N.en.toggleLabel;toggleBtn.classList.toggle('is-en',skxLang==='en');toggleBtn.setAttribute('aria-pressed',String(skxLang==='en'));}
    const pane=document.getElementById('skx-results-pane');if(pane)pane.classList.toggle('is-intl',isIntl);
    const warnDiv=document.getElementById('skx-intl-warning');if(warnDiv)warnDiv.style.display=isIntl?'block':'none';
    const qb=$btn(); if(qb&&!qb.disabled)qb.textContent=_hasQuoted?t('requoteBtn'):t('quoteBtn');
  }

  function updateIntlWarning(){const isIntl=DEST_COUNTRY()!=='MX';const warnDiv=document.getElementById('skx-intl-warning');if(!warnDiv)return;warnDiv.style.display=isIntl?'block':'none';if(isIntl){const txt=document.getElementById('skx-intl-warning-text');if(txt)txt.innerHTML=t('intlWarning');else warnDiv.innerHTML=`<div id="skx-intl-warning-text">${t('intlWarning')}</div>`;}}
  function updateIntlPaneState(){const pane=document.getElementById('skx-results-pane');const isIntl=DEST_COUNTRY()!=='MX';if(pane)pane.classList.toggle('is-intl',isIntl);if(!isIntl&&skxLang==='en'){skxLang='es';try{localStorage.setItem(SKX_LANG_KEY,skxLang);}catch{}}applyLangToPane();}

  function checkUserStatus(){
    const verifyBtn=document.getElementById('verify-user-btn');if(!verifyBtn)return;
    const root=getRoot();const customerId=root?.dataset?.customerId||'';const isLoggedIn=!!(customerId&&customerId.length>0);
    const userAddr=__userAddr();const hasAddr=userAddr?.postal_code&&userAddr?.area_level1&&userAddr?.area_level2;
    verifyBtn.hidden=!((!isLoggedIn)||(isLoggedIn&&!hasAddr));
    const btnText=verifyBtn.querySelector('#verify-user-text');
    if(!isLoggedIn){if(btnText)btnText.textContent='Inicia sesión para continuar';verifyBtn.onclick=()=>{location.href='/account/login?return_url='+encodeURIComponent(location.pathname);};}
    else{if(btnText)btnText.textContent='Completar mi dirección';verifyBtn.onclick=()=>{location.href='/account#addresses';};}
  }

  window.addEventListener('skx:cart-updated',async e=>{
    const updatedCart=e.detail?.cart;if(!updatedCart)return;
    if(updatedCart.items){
      const freshItems=(updatedCart.items||[]).filter(li=>!isEnvioCartItem(li)).map(li=>({vendor:li.vendor||'',quantity:li.quantity,grams:li.grams||0,price_cents:li.final_price||li.price||0,line_price_cents:li.final_line_price||li.line_price||0,product_title:li.product_title||li.title||'',product_id:li.product_id,image:li.image||'',harmonized_code:getDefaultHsCode(),hs_code:getDefaultHsCode()}));
      currentCartItems=freshItems;
      const current=parseJSONText('#skx-cart-payload',{cart:{items:[]}});current.cart.items=freshItems;_jsonCache.set('#skx-cart-payload',current);
      const liveVendorKeys=new Set((updatedCart.items||[]).map(li=>vendorKeyFrom(li.vendor||'')));
      selectedRates.forEach((_,key)=>{if(!liveVendorKeys.has(key))selectedRates.delete(key);});
      saveSelectedToSession();syncAttrInputsFromSelection();
    }
    updateCheckoutEnabled();updateSelectedSummaryUI();computeAndDisplayTotal();
    window.skxWizard?.renderProducts?.(getActiveVendor());
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span').forEach(el=>{el.textContent=updatedCart.item_count;});
  });

  window.skxVendorKey   = vendorKeyFrom;
  window.skxFmtMoney    = fmtMoney;
  window.skxGetCartItems= () => payloadItems();
  window.skxVendorNames = () => Array.from(vendorsInCart().values());

  async function bindSection(){
    clearDomCache();

    checkUserStatus();
    prefillDestinationFromCustomer();
    updateMexicoWarning();
    displayCustomerAddressSummary();
    bindDestInputListeners();
    initAccordions();
    updateAccordionSummaries();
    syncCountryUI();
    initLangToggle();
    applyLangToPane();
    showEdgeWarning();
    const manualBtn=$manualBtn(); if(manualBtn)manualBtn.onclick=()=>selectManualShipping();
    const btn=$btn(); if(btn)btn.onclick=()=>doQuote();
    syncManualShippingButtonUI();
    wireCheckoutButton();
    wireClearRatesButton();
    await buildVendorFormsAndPrefill();
    window.skxWizard.init();

    (async () => {
      try{
        for(let pass=0;pass<4;pass++){
          const cart=await fetchCart();const envio=(cart.items||[]).filter(li=>isEnvioCartItem(li));
          if(!envio.length)break;
          const updates={};envio.forEach(li=>{updates[li.variant_id]=0;});
          await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
          await sleep(pass===0?400:600);
        }
      }catch(e){console.warn('[SKX] envio cleanup failed:',e);}

      const initialCart=await fetchCart().catch(()=>({items:[]}));
      currentCartItems=(initialCart.items||[]).filter(li=>!isEnvioCartItem(li));

      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{skx_selected_rates:'',skx_shipping_total_cents:'0',skx_shipping_title:''}})}).catch(()=>{});

      await Promise.all([prefillOriginsFromBackend(),fetchSkxOptionsAndPopulate()]);
      bindSelectEvents();

      selectedRates.clear();
      loadSelectedFromSession();
      updateIntlWarning();updateIntlPaneState();
      const box=document.getElementById('skx-selected-summary');const lab=document.getElementById('skx-selected-shipping');
      if(box)box.hidden=true;if(lab)lab.textContent='—';
      syncAttrInputsFromSelection();updateCheckoutEnabled();computeAndDisplayTotal();updateMissingOriginsWarning();
    })().catch(()=>{});
  }

  if(!window.__skx_cart_footer_v4_global){
    window.__skx_cart_footer_v4_global=true;
    fetchExchangeRate().then(()=>{startExchangeRateRefresh();if(!exchangeRateApiWorking)scheduleRecovery();}).catch(()=>{});
    const recompute=()=>{_jsonCache.clear();computeAndDisplayTotal();updateCheckoutEnabled();window.skxWizard?.renderProducts?.(getActiveVendor());};
    document.addEventListener('change',e=>{if(e.target?.classList?.contains('quantity__input'))setTimeout(recompute,0);});
    document.addEventListener('click',e=>{if(e.target?.closest?.('.quantity__button'))setTimeout(recompute,0);});
    document.addEventListener('shopify:section:load',()=>{clearDomCache();bindSection().catch(()=>{});setTimeout(recompute,0);},true);
    window.addEventListener('skx:vendor-filter-change',()=>{computeAndDisplayTotal();updateCheckoutEnabled();});
  }

  showEdgeWarning();
  bindSection().catch(()=>{});

  const mobileWelcome = document.getElementById('skx-mobile-welcome');
  if (mobileWelcome) {
    const toggle = () => {
      const expanded = mobileWelcome.classList.toggle('is-expanded');
      mobileWelcome.setAttribute('aria-expanded', String(expanded));
    };
    mobileWelcome.addEventListener('click', toggle);
    mobileWelcome.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
    let _wTouchMoved = false;
    mobileWelcome.addEventListener('touchstart', () => { _wTouchMoved = false; }, { passive: true });
    mobileWelcome.addEventListener('touchmove',  () => { _wTouchMoved = true;  }, { passive: true });
    mobileWelcome.addEventListener('touchend', ev => {
      if (_wTouchMoved) return;
      ev.preventDefault();
      toggle();
    });
  }
})();

/* ===== Split block ===== */

(function () {
  'use strict';
  if (window.__skxResponsiveWorkspaceV3) return;
  window.__skxResponsiveWorkspaceV3 = true;

  var footer = document.getElementById('main-cart-footer');
  var root = document.getElementById('skxWizardRoot');
  var panel = document.getElementById('skxw-p1');
  if (!footer || !root || !panel) return;

  var raf = 0;
  var lastActive = false;

  function isActive() { return !panel.hasAttribute('hidden'); }

  function liveViewportHeight() {
    var vv = window.visualViewport;
    return Math.max(320, Math.round(vv && vv.height ? vv.height : window.innerHeight));
  }

  function applyHeight() {
    raf = 0;
    var active = isActive();
    footer.classList.toggle('skx-shipping-active', active);
    if (!active) {
      footer.style.removeProperty('--skx-live-vh');
      lastActive = false;
      return;
    }

    var h = liveViewportHeight();
    footer.style.setProperty('--skx-live-vh', h + 'px');

    if (!lastActive) {
      lastActive = true;
      try { footer.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' }); } catch (e) {}
      requestAnimationFrame(function () {
        footer.style.setProperty('--skx-live-vh', liveViewportHeight() + 'px');
        var scroller = panel.querySelector(':scope > .skxw-p1-scroll');
        if (scroller) scroller.scrollTop = 0;
      });
    }
  }

  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(applyHeight);
  }

  new MutationObserver(schedule).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(schedule, 80); }, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }
  document.addEventListener('shopify:section:load', schedule, true);
  schedule();
})();

/* ===== Split block ===== */

(function () {
  'use strict';
  if (window.__skxTopWizardDockV5) return;
  window.__skxTopWizardDockV5 = true;

  function mountTopWizardDock() {
    document.body.classList.add('skx-wizard-active');

    var bar = document.querySelector('#skxWizardRoot .skxw-bar')
           || document.querySelector('#skx-top-progress-dock .skxw-bar');
    if (!bar) return;

    var dock = document.getElementById('skx-top-progress-dock');
    if (!dock) {
      dock = document.createElement('div');
      dock.id = 'skx-top-progress-dock';
      dock.setAttribute('aria-label', 'Navegación del proceso de compra');

      var welcome = document.getElementById('skx-cart-welcome-wrapper');
      var cartItems = document.querySelector('cart-items');
      if (welcome && welcome.parentNode) {
        welcome.insertAdjacentElement('afterend', dock);
      } else if (cartItems && cartItems.parentNode) {
        cartItems.parentNode.insertBefore(dock, cartItems);
      } else {
        document.body.insertBefore(dock, document.body.firstChild);
      }
    }

    if (!dock.contains(bar)) dock.appendChild(bar);

    bar.style.removeProperty('display');
  }

  function syncTopOffset() {
    var candidates = [
      document.querySelector('#shopify-section-header'),
      document.querySelector('.shopify-section-group-header-group'),
      document.querySelector('.header-wrapper'),
      document.querySelector('header.header')
    ].filter(Boolean);
    var h = 0;
    for (var i=0;i<candidates.length;i++) {
      var el=candidates[i], cs=getComputedStyle(el), r=el.getBoundingClientRect();
      if ((cs.position==='sticky'||cs.position==='fixed') && r.height>0 && r.bottom>0) { h=Math.max(h,Math.round(r.height)); }
    }
    document.documentElement.style.setProperty('--skx-site-header-h', h+'px');
  }

  function mountSoon() {
    syncTopOffset();
    mountTopWizardDock();
    requestAnimationFrame(function(){syncTopOffset();mountTopWizardDock();});
    setTimeout(function(){syncTopOffset();mountTopWizardDock();}, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountSoon, { once: true });
  } else {
    mountSoon();
  }

  document.addEventListener('shopify:section:load', mountSoon, true);
  window.addEventListener('pageshow', mountSoon);
  window.addEventListener('resize', syncTopOffset, { passive:true });
  window.addEventListener('orientationchange', function(){setTimeout(syncTopOffset,80);}, { passive:true });
  window.addEventListener('scroll', syncTopOffset, { passive:true });
})();

/* ===== Split block ===== */

(function(){
'use strict';if(window.__skxGoldStarScrubV18)return;window.__skxGoldStarScrubV18=1;
var rail=document.createElement('div');rail.id='skx-page-scrub';rail.setAttribute('role','scrollbar');rail.setAttribute('aria-label','Posición en la página');rail.innerHTML='<div id="skx-page-scrub-thumb"><span class="skx-scrub-star-v"></span><span class="skx-scrub-star-h"></span><span class="skx-scrub-star-core"></span></div>';document.body.appendChild(rail);
var thumb=rail.firstChild,drag=0,pid=null,paintRAF=0,maxScroll=0,travel=1,thumbH=48,railTop=0,railH=1,grabOffset=thumbH/2,dragTop=0,dragTravel=1,dragMax=0,lastP=0;
var root=document.documentElement,body=document.body;
function mobile(){return matchMedia('(max-width:749px)').matches}
function headerBottom(){var m=0,a=document.querySelectorAll('#shopify-section-header,.shopify-section-header-sticky,sticky-header,.section-header,.header-wrapper,header.header');for(var i=0;i<a.length;i++){var e=a[i],r=e.getBoundingClientRect(),c=getComputedStyle(e);if(r.height>0&&r.bottom>0&&r.top<innerHeight*.35&&c.display!=='none'&&c.visibility!=='hidden')m=Math.max(m,r.bottom)}return Math.max(10,Math.min(m+8,innerHeight*.34))}
function viewportH(){var vv=window.visualViewport;return vv&&vv.height?vv.height:innerHeight}
function docH(){return Math.max(root.scrollHeight,body?body.scrollHeight:0)}
function measure(){var vh=viewportH(),bottom=12;railTop=headerBottom();railH=Math.max(120,vh-railTop-bottom);rail.style.setProperty('--skx-scrub-top',railTop+'px');rail.style.setProperty('--skx-scrub-h',railH+'px');maxScroll=Math.max(0,docH()-vh);travel=Math.max(1,railH-thumbH);rail.style.display=mobile()&&maxScroll>8?'block':'none'}
function ui(p,t){p=Math.max(0,Math.min(1,p));lastP=p;thumb.style.transform='translate3d(0,'+(p*(t||travel))+'px,0)';rail.setAttribute('aria-valuemin','0');rail.setAttribute('aria-valuemax','100');rail.setAttribute('aria-valuenow',Math.round(p*100))}
function pageY(){return Math.max(0,window.pageYOffset||root.scrollTop||0)}
function paint(){paintRAF=0;if(!mobile())return;if(!drag){measure();ui(maxScroll?pageY()/maxScroll:0)}}
function schedule(){if(!paintRAF)paintRAF=requestAnimationFrame(paint)}
function setLivePosition(clientY){var top=Math.max(0,Math.min(dragTravel,clientY-dragTop-grabOffset));var p=dragTravel?top/dragTravel:0;var y=p*dragMax;ui(p,dragTravel);window.scrollTo(0,y)}
function beginNoSmooth(){root.classList.add('skx-page-scrubbing-root');body.classList.add('skx-page-scrubbing')}
function endNoSmooth(){root.classList.remove('skx-page-scrubbing-root');body.classList.remove('skx-page-scrubbing')}
function startDrag(e){
  if(!mobile())return;
  measure();
  drag=1; pid=e.pointerId; dragTop=railTop; dragTravel=travel; dragMax=maxScroll;
  var onThumb=!!(e.target&&e.target.closest&&e.target.closest('#skx-page-scrub-thumb'));
  if(onThumb){
    var r=thumb.getBoundingClientRect();
    grabOffset=Math.max(0,Math.min(thumbH,e.clientY-r.top));
  }else{
    /* Tapping anywhere on the rail means that exact point in the page. */
    grabOffset=thumbH/2;
  }
  rail.classList.add('is-dragging'); beginNoSmooth();
  try{rail.setPointerCapture(pid)}catch(_){}
  e.preventDefault();
  setLivePosition(e.clientY);
}
rail.addEventListener('pointerdown',startDrag);
rail.addEventListener('pointermove',function(e){
  if(!drag||e.pointerId!==pid)return;
  e.preventDefault();
  var evs=e.getCoalescedEvents?e.getCoalescedEvents():null;
  var y=evs&&evs.length?evs[evs.length-1].clientY:e.clientY;
  setLivePosition(y);
});
function end(e){
  if(!drag||(e&&e.pointerId!==pid))return;
  drag=0; rail.classList.remove('is-dragging');
  try{rail.releasePointerCapture(pid)}catch(_){}
  pid=null; endNoSmooth();
  setTimeout(schedule,0);
}
rail.addEventListener('pointerup',end);
rail.addEventListener('pointercancel',end);
rail.addEventListener('lostpointercapture',function(){if(drag)end()});
addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});addEventListener('orientationchange',function(){setTimeout(schedule,80)},{passive:true});if(window.visualViewport){visualViewport.addEventListener('resize',schedule,{passive:true});visualViewport.addEventListener('scroll',schedule,{passive:true})}if(window.ResizeObserver)new ResizeObserver(function(){if(!drag)schedule()}).observe(root);schedule();
})();
